/**
 * 描述：编辑器插件服务
 * 日期：2017-9-28
 * 作者：Bai.Zhiming
 */
'user strict';
angular.module('ueditorPlugInModule', ['angular-md5']).factory('ueditorPlugIn', [
    '$q',
    'editPictureService',
    '$stateParams',
    'modalDialog',
    'trsHttpService',
    'trsEditVideoService',
    'ueditorService',
    'editingCenterService',
    '$rootScope',
    'localStorageService',
    'previewService',
    'md5',
    '$sessionStorage',
    function (
        $q,
        editPictureService,
        $stateParams,
        modalDialog,
        trsHttpService,
        trsEditVideoService,
        ueditorService,
        editingCenterService,
        $rootScope,
        localStorageService,
        previewService,
        md5,
        $sessionStorage
    ) {

        return {
            media: '',
            isDownloading: false,

            /**
             * [pictureToolbarForApp description] 为客户端定制的工具条
             * @param {[object]} [ue] [description] 编辑器实例
             * @param {[object]} scope [varname] [description] 编辑器指令的作用域
             * @param {[object]} [domUtils] [description] domUtils
             * @param {[object]} [callback] [description] callback 回调函数
             * @return {[type]} [description]
             */
            pictureToolbarForApp: function (ue, scope, domUtils, callback) {
                // 图片工具条代码开始
                var popup = new baidu.editor.ui.Popup({
                    editor: ue,
                    content: '',
                    className: 'edui-bubble-app',
                    _onImgEditButtonClick: function (name) {
                        this.hide();
                        ue.ui._dialogs[name] && ue.ui._dialogs[name].open();
                    },
                    // 下载原图
                    _onImgDownOriginalGraph: function () {
                        ueditorService.downLoadOriginImage(popup);
                    },
                    // 搜图
                    _onSearchImg: function () {
                        editingCenterService
                            .picSearch({
                                imageUrl: popup.anchorEl.src,
                            })
                            .then((data) => {
                                ueditorService.insertImages(data.list).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.focus(true, popup.anchorEl.parentNode.nextElementSibling);
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                    },
                    // 圖片编辑
                    _onImgclipping: function () {
                        this.hide();
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var image = {
                                    PERPICURL: data,
                                    APPFILE: angular.isDefined($(img).attr('uploadpic'))
                                        ? $(img).attr('uploadpic')
                                        : $(img)
                                            .attr('src')
                                            .split('/')[
                                                $(img)
                                                    .attr('src')
                                                    .split('/').length - 1
                                            ], // angular.isDefined($(img).attr("oldsrc")) ? $(img).attr("oldsrc") : $(img).attr("uploadpic")
                                };
                                scope.photoFileName = image.APPFILE;
                                var siteId = $stateParams.wzsiteid || $stateParams.appsiteid;
                                editPictureService.editPicture(image, siteId, function (params) {
                                    var myImg = new Image();
                                    var sFileName = params.imgName || params.FN;
                                    var imageUrl = '/wcm/file/read_image.jsp?FileName=' + sFileName; // 文件没有保存之后，是U0开头
                                    if (sFileName.match(/^W0/)) {
                                        imageUrl = ['/webpic/', sFileName.substring(0, 8), '/', sFileName.substring(0, 10), '/', sFileName].join('');
                                        // imageUrl += "?r=" + new Date().getTime(); // 添加水印之后，图片名称不变，防止图片不刷新
                                    }
                                    myImg.src = imageUrl;
                                    myImg.onload = function () {
                                        var aspectRatio = myImg.width / myImg.height;
                                        var width = myImg.width > 640 ? 640 : myImg.width;
                                        var height = myImg.width > 640 ? 640 / aspectRatio : myImg.height;
                                        domUtils.setAttributes(img, {
                                            src: imageUrl,
                                            uploadpic: sFileName,
                                            _src: imageUrl,
                                        });
                                        if ($(img).parents('figure').length == 0) {
                                            // app渠道不需要做图片固定宽高的处理
                                            domUtils.setAttributes(img, {
                                                width: width + 'px',
                                                height: height + 'px',
                                            });
                                            domUtils.setStyles(img, {
                                                width: width + 'px',
                                                height: height + 'px',
                                            });
                                        }
                                        // img.style.width = myWidth;
                                        // img.style.height = 'auto';
                                        ue.fireEvent('contentchange');
                                    };
                                });
                            }
                        });
                    },

                    /* 扩展方法，设置图片区域自定义尺寸 */
                    _onImgResize: function (value) {
                        value = value.replace('px', '');
                        if (isNaN(value)) {
                            this.hide();
                            return;
                        } else if (value > 640) {
                            // 客户端由于要在手机上显示，图片最大宽度不能超过640px
                            this.hide();
                            return;
                        } else {
                            var img = popup.anchorEl;
                            var percent = 0;
                            if (img.naturalWidth > 0) {
                                percent = img.naturalHeight / img.naturalWidth;
                            }

                            domUtils.setAttributes(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                            domUtils.setStyles(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                        }
                        domUtils.on(document.body, 'keydown');
                        this.hide();
                    },
                    _enterEvent: function (_dom) {
                        popup._onImgResize(_dom.value + 'px');
                    },

                    /* 扩展方法，设置图片区域指定尺寸 */
                    _onImgSetSize: function (value) {
                        var img = popup.anchorEl;
                        var percent = 0;
                        if (img.naturalWidth > 0) {
                            percent = img.naturalHeight / img.naturalWidth;
                        }

                        if (img && img.tagName === 'IMG') {
                            switch (value) {
                                case 'small':
                                    domUtils.setAttributes(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    break;
                                case 'middle':
                                    domUtils.setAttributes(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    break;
                                case 'big':
                                    domUtils.setAttributes(img, {
                                        width: '500px',
                                        height: 500 * percent == 0 ? '' : 500 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '500px',
                                        height: 500 * percent == 0 ? '' : 500 * percent + 'px',
                                    });
                                    break;
                                case 'original':
                                    domUtils.setAttributes(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    domUtils.setStyles(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    // 兼容设置原始大小时，图片变形 --jira-1826 add by:SongJian
                                    domUtils.removeStyle(img, 'max-width');
                                    break;
                                case 'border':
                                    if (img.border != '1') {
                                        img.border = '1';
                                    } else {
                                        img.border = '';
                                    }

                                    break;
                            }
                        }
                        ue.fireEvent('contentChange');
                        // this.hide();
                    },
                    _setAsOutlinepics: function (imgSrc) {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                imgSrc = data;
                                var meiziid = $(img).attr('meiziid');
                                var relationid = $(img).attr(relationid);
                                var splitString = imgSrc.indexOf('FileName=') > 0 ? 'FileName=' : '/';
                                var imgSrcArray = imgSrc.split(splitString);
                                var imgName = imgSrcArray[imgSrcArray.length - 1];
                                var flag = true;
                                var newOutlinePic = {
                                    APPDESC: imgName,
                                    APPFILE: imgName,
                                    PERPICURL: imgSrc || '/wcm/openapi/readimg?ScaleWidth=600&FileName=' + imgName,
                                    meiziid: meiziid,
                                    relationid: relationid,
                                };
                                for (var i = 0; i < scope.list.OUTLINEPICS.length; i++) {
                                    var outlinePic = scope.list.OUTLINEPICS[i];
                                    if (outlinePic.PERPICURL === '' || angular.isUndefined(outlinePic.PERPICURL)) {
                                        flag = false;
                                        scope.list.OUTLINEPICS.splice(i, 1, newOutlinePic);
                                        break;
                                    }
                                }
                                if (flag && scope.list.OUTLINEPICS.length < 10) {
                                    scope.list.OUTLINEPICS.push(newOutlinePic);
                                } else if (scope.list.OUTLINEPICS.length >= 10) {
                                    modalDialog.alertType('最多添加十张导图!', '', 'error', false);
                                    return;
                                }
                                modalDialog.alertType('设为导图成功', '', 'success', false);
                            }
                        });
                    },
                    _onAddImgToCoverImage: function () {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var fileString = data,
                                    index = fileString.indexOf('='),
                                    fileName;
                                let host = window.location.host;
                                var protocol = fileString.indexOf('https:// ') === 0 ? 'https:// ' : 'http:// ';
                                var startIndex = protocol == 'http:// ' ? 7 : 8;
                                var hostName = fileString.substring(startIndex);
                                var endIndex = hostName.indexOf('/');
                                hostName = hostName.substring(0, endIndex);
                                // if (fileString[0] != '/' && hostName != host) {
                                // modalDialog.alertType('该图片为外部图片，不允许设置为列表图', '', 'warning', 'confirm');
                                // return;
                                // }
                                if (index > 0 && fileString.indexOf('readimg') !== -1) {
                                    fileString = fileString.split('=');
                                    fileName = fileString[fileString.length - 1];
                                } else {
                                    index = fileString.lastIndexOf('/');
                                    fileName = fileString.substring(index + 1, fileString.length).split('?')[0];
                                }
                                var fileObj = {
                                    img: img,
                                    imgName: fileName,
                                    imgSrc: $(img).attr('src'),
                                };
                                callback(fileObj);
                            }
                        });
                    },
                    // 添加为焦点图
                    _onAddImgToFocusImage: function () {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var fileString = data,
                                    index = fileString.indexOf('='),
                                    fileName;
                                let host = window.location.host;
                                var protocol = fileString.indexOf('https:// ') === 0 ? 'https:// ' : 'http:// ';
                                var startIndex = protocol == 'http:// ' ? 7 : 8;
                                var hostName = fileString.substring(startIndex);
                                var endIndex = hostName.indexOf('/');
                                hostName = hostName.substring(0, endIndex);
                                // if (fileString[0] != '/' && hostName != host) {
                                // modalDialog.alertType('该图片为外部图片，不允许设置为列表图', '', 'warning', 'confirm');
                                // return;
                                // }
                                if (index > 0 && fileString.indexOf('readimg') !== -1) {
                                    fileString = fileString.split('=');
                                    fileName = fileString[fileString.length - 1];
                                } else {
                                    index = fileString.lastIndexOf('/');
                                    fileName = fileString.substring(index + 1, fileString.length).split('?')[0];
                                }
                                var fileObj = {
                                    img: img,
                                    imgName: fileName,
                                    imgSrc: $(img).attr('src'),
                                    type: 'focus',
                                };
                                callback(fileObj);
                            }
                        });
                    },
                    // 设置超链接
                    _setLink(type) {
                        if (type === 'link') {
                            let dialog = ue.ui._dialogs['linkDialog'];
                            dialog.render();
                            dialog.open();
                        } else {
                            ue.execCommand('unlink');
                            popup.hide();
                        }
                    },
                });
                popup.render();
                UE.plugins['addborder'] = function () {
                    var me = this;
                    // 创建一个改变图片边框的命令
                    me.commands['addborder'] = {
                        execCommand: function () {
                            // 获取当前选区
                            var range = me.selection.getRange();
                            // 选区没闭合的情况下操作
                            if (!range.collapsed) {
                                // 图片判断
                                var img = range.getClosedNode();
                                if (img && img.tagName == 'IMG') {
                                    // 点击切换图片边框
                                    img.style.border = img.style.borderWidth == '5px' ? '1px' : '5px solid red';
                                }
                            }
                        },
                    };
                };
                // 注册一个触发命令的事件，同学们可以在任意地放绑定触发此命令的事件
                ue.addListener('selectionchange', function (t, evt) {
                    //  if (!causeByUi) return;
                    var html = '',
                        str = '',
                        img = ue.selection.getRange().getClosedNode();
                    if (img && img.tagName === 'IMG' && $(img).attr('videoid') === undefined && $(img).attr('audioid') === undefined) {
                        var dialogName = 'insertimageDialog';
                        if (img.className.indexOf('edui-faked-video') != -1 || img.className.indexOf('edui-upload-video') != -1) {
                            dialogName = 'insertvideoDialog';
                        }
                        if (img.className.indexOf('edui-faked-webapp') != -1) {
                            dialogName = 'webappDialog';
                        }
                        if (img.src.indexOf('http:// api.map.baidu.com') != -1) {
                            dialogName = 'mapDialog';
                        }
                        if (img.className.indexOf('edui-faked-music') != -1) {
                            dialogName = 'musicDialog';
                        }
                        if (img.src.indexOf('http:// maps.google.com/maps/api/staticmap') != -1) {
                            dialogName = 'gmapDialog';
                        }
                        if (img.getAttribute('anchorname')) {
                            dialogName = 'anchorDialog';
                            html = popup.formatHtml(
                                '<nobr>' +
                                ue.getLang('property') +
                                ': <span onclick=$$._onImgEditButtonClick("anchorDialog") class="edui-clickable">' +
                                editor.getLang('modify') +
                                '</span>&nbsp;&nbsp;' +
                                '<span onclick=$$._onRemoveButtonClick(\'anchor\') class="edui-clickable">' +
                                editor.getLang('delete') +
                                '</span></nobr>'
                            );
                        }
                        if (img.getAttribute('word_img')) {
                            // todo 放到dialog去做查询
                            ue.word_img = [img.getAttribute('word_img')];
                            dialogName = 'wordimageDialog';
                        }
                        var isGif = editPictureService.isGif($(img).attr('src'));
                        str =
                            '<nobr>' +
                            '&nbsp;<span><input onchange=$$._enterEvent(this) onclick=this.focus();this.select(); type="text" style="width:40px" value="' +
                            img.clientWidth +
                            '">px</span>&nbsp;&nbsp;' +
                            '<span onclick=$$._onImgSetSize("small") class="edui-clickable smallpic">' +
                            '▪' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("middle") class="edui-clickable normal">' +
                            '■' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("big") class="edui-clickable bigpic">' +
                            '█' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("original") class="edui-clickable ori-pic">' +
                            '原始大小' +
                            '</span> ' +
                            '<span onclick=$$._onImgSetSize("border") class="edui-clickable pic-border">' +
                            '边框' +
                            '</span> ';
                        if (!isGif) {
                            str += '<span onclick=$$._onImgclipping() class="edui-clickable pic-cut">' +
                                '编辑' +
                                '</span> ';
                        }
                        // '<span onclick="$$._onImgEditButtonClick(\'' +
                        // dialogName +
                        // '\');" class="edui-clickable pic-pro">' +
                        // '属性' +
                        // '</span> ' +
                        str +=
                            '<span onclick="$$._onSearchImg();" class="edui-clickable pic-cut">' +
                            '搜图' +
                            '</span> ' +
                            '<span onclick=$$._onImgDownOriginalGraph() class="edui-clickable pic-cut download-pic">' +
                            '下载原图' +
                            '</span> ' +
                            '<span onclick=$$._onAddImgToCoverImage() class="edui-clickable pic-cut add-list-pic">' +
                            '添加为列表图' +
                            '</span> ' +
                            '<span onclick=$$._onAddImgToFocusImage() class="edui-clickable pic-cut add-list-pic">' +
                            '添加为焦点图' +
                            '</span> ';
                        // 网站渠道增加设为导图功能（编辑器中的图片可以直接设为导图）
                        if (scope.type === 'website') {
                            str +=
                                '<span onclick="$$._setAsOutlinepics(\'' +
                                img.getAttribute('src') +
                                '\');" style="width:64px" class="edui-clickable pic-pro">' +
                                '设为导图' +
                                '</span>';
                        }
                        let $imageWrap = $(img).parent();
                        if (($imageWrap && $imageWrap.length && $imageWrap[0].tagName === 'A') || $imageWrap[0].tagName === 'a') {
                            var url;
                            var txt = (url = $imageWrap.attr('href'));
                            var target = $imageWrap.attr('target');
                            if (url.length > 30) {
                                txt = url.substring(0, 20) + '...';
                            }
                            str +=
                                '\u3000' +
                                ue.getLang('anthorMsg') +
                                ': <a target="_blank" href="' +
                                url +
                                '" title="' +
                                url +
                                '" >' +
                                txt +
                                '</a>' +
                                ' <span class="edui-clickable pic-cut download-pic" onclick="$$._setLink(\'link\');">' +
                                ue.getLang('modify') +
                                '</span>' +
                                ' <span class="edui-clickable pic-cut download-pic" onclick="$$._setLink(\'unlink\');"> ' +
                                ue.getLang('clear') +
                                '</span>';
                        } else {
                            str += '\u3000' + ' <span class="edui-clickable pic-cut download-pic" onclick="$$._setLink(\'link\');">超链接</span>';
                        }
                        str += '</nobr>';
                        !html && (html = popup.formatHtml(str));
                        if (img.getAttribute('feature')) {
                            // 插入活动和广告暂时不用显示编辑图片
                            popup.hide();
                            return;
                        }
                        if (html) {
                            popup.getDom('content').innerHTML = html;
                            popup.anchorEl = img;
                            popup.showAnchor(popup.anchorEl);
                        } else {
                            popup.hide();
                        }
                    } else {
                        popup.hide();
                    }
                });
            },

            /**
             * [pictureToolbarForWeixin description] 为微信定制的工具条
             * @param {[object]} [ue] [description] 编辑器实例
             * @param {[object]} scope [varname] [description] 编辑器指令的作用域
             * @param {[object]} [domUtils] [description] domUtils
             * @param {[object]} [callback] [description] callback 回调函数
             * @return {[type]} [description]
             */
            pictureToolbarForWeixin: function (ue, scope, domUtils, callback) {
                // 图片工具条代码开始
                var popup = new baidu.editor.ui.Popup({
                    editor: ue,
                    content: '',
                    className: 'edui-bubble',
                    _onImgEditButtonClick: function (name) {
                        this.hide();
                        ue.ui._dialogs[name] && ue.ui._dialogs[name].open();
                    },
                    // 搜图
                    _onSearchImg: function () {
                        editingCenterService
                            .picSearch({
                                imageUrl: popup.anchorEl.src,
                            })
                            .then((data) => {
                                ueditorService.insertImages(data.list).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.focus(true, popup.anchorEl.parentNode.nextElementSibling);
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                    },
                    // 下载原图
                    _onImgDownOriginalGraph: function () {
                        ueditorService.downLoadOriginImage(popup);
                    },
                    // 圖片编辑
                    _onImgclipping: function () {
                        this.hide();
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var image = {
                                    PERPICURL: data,
                                    APPFILE: angular.isDefined($(img).attr('uploadpic'))
                                        ? $(img).attr('uploadpic')
                                        : $(img)
                                            .attr('src')
                                            .split('/')[
                                                $(img)
                                                    .attr('src')
                                                    .split('/').length - 1
                                            ], // angular.isDefined($(img).attr("oldsrc")) ? $(img).attr("oldsrc") : $(img).attr("uploadpic")
                                };
                                scope.photoFileName = image.APPFILE;
                                var siteId = $stateParams.wzsiteid || $stateParams.appsiteid;
                                editPictureService.editPicture(image, siteId, function (params) {
                                    var myImg = new Image();
                                    var sFileName = params.imgName || params.FN;
                                    var imageUrl = '/wcm/file/read_image.jsp?FileName=' + sFileName; // 文件没有保存之后，是U0开头
                                    if (sFileName.match(/^W0/)) {
                                        imageUrl = ['/webpic/', sFileName.substring(0, 8), '/', sFileName.substring(0, 10), '/', sFileName].join('');
                                        // imageUrl += "?r=" + new Date().getTime(); // 添加水印之后，图片名称不变，防止图片不刷新
                                    }
                                    myImg.src = imageUrl;
                                    myImg.onload = function () {
                                        // 如果原图很大的话，添加水印之后，图片就变小了，这个不合理。
                                        // 应该是水印后图片超过了编辑器中图片的大小，则需要减小之编辑器图片大小
                                        // myHeight = myImg.naturalWidth > 640 ? 640 : 'auto';
                                        // myWidth = myImg.width > 640 ? 640 : 'auto';
                                        // var offsetWidth = parseInt(img.offsetWidth, 10);
                                        // myWidth = myImg.width // > offsetWidth ? (offsetWidth + "px") : myImg.width;

                                        var aspectRatio = myImg.width / myImg.height;
                                        var width = myImg.width > 470 ? 470 : myImg.width;
                                        var height = myImg.width > 470 ? 470 / aspectRatio : myImg.height;
                                        domUtils.setAttributes(img, {
                                            src: imageUrl,
                                            uploadpic: sFileName,
                                            _src: imageUrl,
                                            // "height":myImg.height
                                            // width: myWidth,
                                            // height: 'inital'
                                        });
                                        if ($(img).parents('figure').length == 0) {
                                            // app渠道不需要做图片固定宽高的处理
                                            domUtils.setAttributes(img, {
                                                width: width + 'px',
                                                height: height + 'px',
                                            });
                                            domUtils.setStyles(img, {
                                                width: width + 'px',
                                                height: height + 'px',
                                            });
                                        }
                                        // img.style.width = myWidth;
                                        // img.style.height = 'auto';
                                        ue.fireEvent('contentchange');
                                    };
                                });
                            }
                        });

                    },

                    /* 扩展方法，设置图片区域自定义尺寸*/
                    _onImgResize: function (value) {
                        value = value.replace('px', '');
                        if (isNaN(value)) {
                            this.hide();
                            return;
                        } else {
                            var img = popup.anchorEl;
                            var percent = 0;
                            if (img.naturalWidth > 0) {
                                percent = img.naturalHeight / img.naturalWidth;
                            }

                            domUtils.setAttributes(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                            domUtils.setStyles(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                        }
                        domUtils.on(document.body, 'keydown');
                        this.hide();
                    },
                    _enterEvent: function (_dom) {

                        /* domUtils.on(document.body, "keydown", function(evt) {
                            if (evt.keyCode == 13) { // 回车事件
                                popup._onImgResize(_dom.value);
                            }
                        });*/
                        popup._onImgResize(_dom.value + 'px');
                    },

                    /* 扩展方法，设置图片区域指定尺寸*/
                    _onImgSetSize: function (value) {
                        var img = popup.anchorEl;

                        // img.src = "";
                        // img.setAttribute("uploadpic", "");

                        var percent = 0;
                        if (img.naturalWidth > 0) {
                            percent = img.naturalHeight / img.naturalWidth;
                        }

                        if (img && img.tagName == 'IMG') {
                            switch (value) {
                                case 'small':
                                    domUtils.setAttributes(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    break;
                                case 'middle':
                                    domUtils.setAttributes(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    break;
                                case 'big':
                                    domUtils.setAttributes(img, {
                                        width: '470px',
                                        height: 470 * percent == 0 ? '' : 470 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '470px',
                                        height: 470 * percent == 0 ? '' : 470 * percent + 'px',
                                    });
                                    break;
                                case 'original':
                                    domUtils.setAttributes(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    domUtils.setStyles(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    // 兼容设置原始大小时，图片变形 --jira-1826 add by:SongJian
                                    domUtils.removeStyle(img, 'max-width');
                                    break;
                                case 'border':
                                    if (img.border != '1') {
                                        img.border = '1';
                                    } else {
                                        img.border = '';
                                    }

                                    break;
                            }
                        }
                        ue.fireEvent('contentChange');
                        // this.hide();
                    },
                    _setAsOutlinepics: function (imgSrc) {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                imgSrc = data;
                                var meiziid = $(img).attr('meiziid');
                                var relationid = $(img).attr('relationid');
                                var splitString = imgSrc.indexOf('FileName=') > 0 ? 'FileName=' : '/';
                                var imgSrcArray = imgSrc.split(splitString);
                                var imgName = imgSrcArray[imgSrcArray.length - 1];
                                var flag = true;
                                var newOutlinePic = {
                                    APPDESC: imgName,
                                    APPFILE: imgName,
                                    PERPICURL: imgSrc || '/wcm/openapi/readimg?ScaleWidth=600&FileName=' + imgName,
                                    meiziid: meiziid,
                                    relationid: relationid,
                                };
                                for (var i = 0; i < scope.list.OUTLINEPICS.length; i++) {
                                    var outlinePic = scope.list.OUTLINEPICS[i];
                                    if (outlinePic.PERPICURL === '' || angular.isUndefined(outlinePic.PERPICURL)) {
                                        flag = false;
                                        scope.list.OUTLINEPICS.splice(i, 1, newOutlinePic);
                                        break;
                                    }
                                }
                                if (flag && scope.list.OUTLINEPICS.length < 10) {
                                    scope.list.OUTLINEPICS.push(newOutlinePic);
                                } else if (scope.list.OUTLINEPICS.length >= 10) {
                                    modalDialog.alertType('最多添加十张导图!', '', 'error', false);
                                    return;
                                }
                                modalDialog.alertType('设为导图成功', '', 'success', false);
                            }
                        });

                    },
                    _onAddImgToCoverImage: function () {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var fileString = data,
                                    index = fileString.indexOf('='),
                                    fileName;
                                var file = { imgSrc: fileString };
                                var protocol = fileString.indexOf('https:// ') === 0 ? 'https:// ' : 'http:// ';
                                var startIndex = protocol == 'http:// ' ? 7 : 8;
                                var hostName = fileString.substring(startIndex);
                                var endIndex = hostName.indexOf('/');
                                hostName = hostName.substring(0, endIndex);
                                let host = window.location.host;
                                // if (fileString[0] != '/' && hostName != host) {
                                //     modalDialog.alertType('该图片为外部图片，不允许设置为封面图片', '', 'warning', 'confirm');
                                //     return;
                                // }
                                if (index > 0) {
                                    fileString = fileString.split('=');
                                    fileName = fileString[fileString.length - 1];
                                } else {
                                    index = fileString.lastIndexOf('/');
                                    fileName = fileString.substring(index + 1, fileString.length);
                                }
                                if (fileName.indexOf('W0') === -1 && fileName.indexOf('ST') === -1 && fileName.indexOf('U0') === -1) {
                                    callback(file);
                                } else {
                                    callback(fileName);
                                }
                            }
                        });
                    },
                });
                popup.render();
                UE.plugins['addborder'] = function () {
                    var me = this;
                    //  创建一个改变图片边框的命令
                    me.commands['addborder'] = {
                        execCommand: function () {
                            //  获取当前选区
                            var range = me.selection.getRange();
                            //  选区没闭合的情况下操作
                            if (!range.collapsed) {
                                //  图片判断
                                var img = range.getClosedNode();
                                if (img && img.tagName == 'IMG') {
                                    //  点击切换图片边框
                                    img.style.border = img.style.borderWidth == '5px' ? '1px' : '5px solid red';
                                }
                            }
                        },
                    };
                };
                //  注册一个触发命令的事件，同学们可以在任意地放绑定触发此命令的事件
                ue.addListener('selectionchange', function (t, evt) {
                    //  if (!causeByUi) return;
                    var html = '',
                        str = '',
                        img = ue.selection.getRange().getClosedNode();
                    if (img && img.tagName === 'IMG' && $(img).attr('videoid') === undefined && $(img).attr('audioid') === undefined) {
                        var dialogName = 'insertimageDialog';
                        if (img.className.indexOf('edui-faked-video') != -1 || img.className.indexOf('edui-upload-video') != -1) {
                            dialogName = 'insertvideoDialog';
                        }
                        if (img.className.indexOf('edui-faked-webapp') != -1) {
                            dialogName = 'webappDialog';
                        }
                        if (img.src.indexOf('http:// api.map.baidu.com') != -1) {
                            dialogName = 'mapDialog';
                        }
                        if (img.className.indexOf('edui-faked-music') != -1) {
                            dialogName = 'musicDialog';
                        }
                        if (img.src.indexOf('http:// maps.google.com/maps/api/staticmap') != -1) {
                            dialogName = 'gmapDialog';
                        }
                        if (img.getAttribute('anchorname')) {
                            dialogName = 'anchorDialog';
                            html = popup.formatHtml(
                                '<nobr>' +
                                ue.getLang('property') +
                                ': <span onclick=$$._onImgEditButtonClick("anchorDialog") class="edui-clickable">' +
                                editor.getLang('modify') +
                                '</span>&nbsp;&nbsp;' +
                                '<span onclick=$$._onRemoveButtonClick(\'anchor\') class="edui-clickable">' +
                                editor.getLang('delete') +
                                '</span></nobr>'
                            );
                        }
                        if (img.getAttribute('word_img')) {
                            // todo 放到dialog去做查询
                            ue.word_img = [img.getAttribute('word_img')];
                            dialogName = 'wordimageDialog';
                        }
                        let isGif = editPictureService.isGif($(img).attr('src'));
                        str =
                            '<nobr>' +
                            '&nbsp;<span><input onchange=$$._enterEvent(this) onclick=this.focus();this.select(); type="text" style="width:40px" value="' +
                            img.clientWidth +
                            '"> px</span>&nbsp;&nbsp;' +
                            '<span onclick=$$._onImgSetSize("small") class="edui-clickable smallpic">' +
                            '▪' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("middle") class="edui-clickable normal">' +
                            '■' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("big") class="edui-clickable bigpic">' +
                            '█' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("original") class="edui-clickable ori-pic">' +
                            '原始大小' +
                            '</span> ' +
                            '<span onclick=$$._onImgSetSize("border") class="edui-clickable pic-border">' +
                            '边框' +
                            '</span> ';
                        if (!isGif) {
                            str += '<span onclick=$$._onImgclipping() class="edui-clickable pic-cut">' +
                                '编辑' +
                                '</span> ';
                        }
                        // '<span onclick="$$._onImgEditButtonClick(\'' +
                        // dialogName +
                        // '\');" class="edui-clickable pic-pro">' +
                        // '属性' +
                        // '</span> ' +
                        str += '<span onclick=$$._onImgDownOriginalGraph() class="edui-clickable download-pic">' +
                            '下载原图' +
                            '</span> ';
                        if (!isGif) {
                            str +=
                                '<span onclick=$$._onAddImgToCoverImage() class="edui-clickable add-list-pic">' +
                                '添加为封面图' +
                                '</span> ';
                        }
                        //  网站渠道增加设为导图功能（编辑器中的图片可以直接设为导图）
                        if (scope.type === 'website') {
                            str +=
                                '<span onclick="$$._setAsOutlinepics(\'' +
                                img.getAttribute('src') +
                                '\');" style="width:64px" class="edui-clickable pic-pro">' +
                                '设为导图' +
                                '</span>';
                        }
                        str += '</nobr>';
                        !html && (html = popup.formatHtml(str));
                        if (html) {
                            popup.getDom('content').innerHTML = html;
                            popup.anchorEl = img;
                            popup.showAnchor(popup.anchorEl);
                        } else {
                            popup.hide();
                        }
                    } else {
                        popup.hide();
                    }
                });

                ue.addListener('click', function (t, evt) {
                    if (!evt) {return;}
                    var target = evt.target;
                    if ($(target)[0].tagName !== 'IMG') {
                        return;
                    }
                    var range = ue.selection.getRange();
                    var img = range.getClosedNode();
                    if ($(img).attr('isrotate')) {
                        setTimeout(() => {
                            var $imageScales = $('.edui-editor-imagescale', window.parent.document);
                            if ($imageScales.length) {
                                $imageScales.rotate($(img).attr('isrotate'));
                            }
                        }, 0);
                    }
                });


            },

            /**
             * [pictureToolbar description] 编辑器工具条
             * @param {[object]} [ue] [description] 编辑器实例
             * @param {[object]} scope [varname] [description] 编辑器指令的作用域
             * @param {[object]} [domUtils] [description] domUtils
             * @return {[type]} [description]
             */
            pictureToolbar: function (ue, scope, domUtils) {
                //  图片工具条代码开始
                var popup = new baidu.editor.ui.Popup({
                    editor: ue,
                    content: '',
                    className: 'edui-bubble',
                    _onImgEditButtonClick: function (name) {
                        this.hide();
                        ue.ui._dialogs[name] && ue.ui._dialogs[name].open();
                    },
                    //  下载原图
                    _onImgDownOriginalGraph: function () {
                        ueditorService.downLoadOriginImage(popup);
                    },
                    //  圖片编辑
                    _onImgclipping: function () {
                        this.hide();
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                var image = {
                                    PERPICURL: data,
                                    APPFILE: angular.isDefined($(img).attr('uploadpic'))
                                        ? $(img).attr('uploadpic')
                                        : $(img)
                                            .attr('src')
                                            .split('/')[
                                                $(img)
                                                    .attr('src')
                                                    .split('/').length - 1
                                            ],
                                };
                                scope.photoFileName = image.APPFILE;
                                var siteId = $stateParams.wzsiteid || $stateParams.appsiteid;
                                editPictureService.editPicture(image, siteId, function (params) {
                                    var myImg = new Image();
                                    var sFileName = params.imgName || params.FN;
                                    var imageUrl = '/wcm/file/read_image.jsp?FileName=' + sFileName; // 文件没有保存之后，是U0开头
                                    if (sFileName.match(/^W0/)) {
                                        imageUrl = ['/webpic/', sFileName.substring(0, 8), '/', sFileName.substring(0, 10), '/', sFileName].join('');
                                    }
                                    myImg.src = imageUrl;
                                    myImg.onload = function () {
                                        //  如果原图很大的话，添加水印之后，图片就变小了，这个不合理。
                                        //  应该是水印后图片超过了编辑器中图片的大小，则需要减小之编辑器图片大小
                                        var aspectRatio = this.width / this.height; //
                                        var width = this.width > 640 ? 640 : this.width;
                                        var height = this.width > 640 ? 640 / aspectRatio : this.height;
                                        domUtils.setAttributes(img, {
                                            src: imageUrl,
                                            uploadpic: sFileName,
                                            _src: imageUrl,
                                            width,
                                            height,
                                        });
                                        ue.fireEvent('contentchange');
                                    };
                                });
                            }
                        });
                    },
                    //  扩展方法，设置图片区域自定义尺寸
                    _onImgResize: function (value) {
                        value = value.replace('px', '');
                        if (isNaN(value)) {
                            this.hide();
                            return;
                        } else {
                            var img = popup.anchorEl;
                            var percent = 0;
                            if (img.naturalWidth > 0) {
                                percent = img.naturalHeight / img.naturalWidth;
                            }

                            domUtils.setAttributes(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                            domUtils.setStyles(img, {
                                width: value + 'px',
                                height: value * percent == 0 ? '' : value * percent + 'px',
                            });
                        }
                        domUtils.on(document.body, 'keydown');
                        this.hide();
                    },
                    // 以图搜图
                    _onSearchImg: function () {
                        editingCenterService
                            .picSearch({
                                imageUrl: popup.anchorEl.src,
                            })
                            .then((data) => {
                                ueditorService.insertImages(data.list).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.focus(true, popup.anchorEl.parentNode.nextElementSibling);
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                    },
                    _enterEvent: function (_dom) {
                        popup._onImgResize(_dom.value + 'px');
                    },
                    //  扩展方法，设置图片区域指定尺寸*/
                    _onImgSetSize: function (value) {
                        var img = popup.anchorEl;
                        var percent = 0;
                        if (img.naturalWidth > 0) {
                            percent = img.naturalHeight / img.naturalWidth;
                        }

                        if (img && img.tagName == 'IMG') {
                            switch (value) {
                                case 'small':
                                    domUtils.setAttributes(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '100px',
                                        height: 100 * percent == 0 ? '' : 100 * percent + 'px',
                                    });
                                    break;
                                case 'middle':
                                    domUtils.setAttributes(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '300px',
                                        height: 300 * percent == 0 ? '' : 300 * percent + 'px',
                                    });
                                    break;
                                case 'big':
                                    domUtils.setAttributes(img, {
                                        width: '500px',
                                        height: 500 * percent == 0 ? '' : 500 * percent + 'px',
                                    });
                                    domUtils.setStyles(img, {
                                        width: '500px',
                                        height: 500 * percent == 0 ? '' : 500 * percent + 'px',
                                    });
                                    break;
                                case 'original':
                                    domUtils.setAttributes(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    domUtils.setStyles(img, {
                                        width: img.naturalWidth ? img.naturalWidth + 'px' : '',
                                        height: img.naturalHeight ? img.naturalHeight + 'px' : '',
                                    });
                                    // 兼容设置原始大小时，图片变形 --jira-1826 add by:SongJian
                                    domUtils.removeStyle(img, 'max-width');
                                    break;
                                case 'border':
                                    if (img.border != '1') {
                                        img.border = '1';
                                    } else {
                                        img.border = '';
                                    }

                                    break;
                            }
                        }
                        ue.fireEvent('contentChange');
                    },
                    _setAsOutlinepics: function (imgSrc) {
                        var img = popup.anchorEl;
                        isEditCenterImg(img).then(function (data) {
                            if (data) {
                                imgSrc = data;
                                var meiziid = $(img).attr('meiziid');
                                var relationid = $(img).attr('relationid');
                                let host = window.location.host;
                                var protocol = imgSrc.indexOf('https:// ') === 0 ? 'https:// ' : 'http:// ';
                                var startIndex = protocol == 'http:// ' ? 7 : 8;
                                var hostName = imgSrc.substring(startIndex);
                                var endIndex = hostName.indexOf('/');
                                hostName = hostName.substring(0, endIndex);
                                let reg = /([WUP]0|ST)+[123]\d{3}[01][0-9][0-3][0-9]/gi;
                                if (!reg.test(imgSrc)) {
                                    modalDialog.alertType('该图片为外部图片，不允许设置为导读图片', '', 'warning', 'confirm');
                                    return;
                                }
                                var splitString = imgSrc.indexOf('FileName=') > 0 ? 'FileName=' : '/';
                                var imgSrcArray = imgSrc.split(splitString);
                                var imgName = imgSrcArray[imgSrcArray.length - 1];
                                var flag = true;
                                var newOutlinePic = {
                                    APPDESC: imgName,
                                    APPFILE: imgName,
                                    PERPICURL: imgSrc || '/wcm/openapi/readimg?ScaleWidth=600&FileName=' + imgName,
                                    meiziid: meiziid,
                                    relationid: relationid,
                                };
                                if (
                                    scope.list.OUTLINEPICS[scope.list.OUTLINEPICS.length - 1].APPFILE == '' &&
                                    scope.list.OUTLINEPICS[scope.list.OUTLINEPICS.length - 1].APPDESC == ''
                                ) {
                                    scope.list.OUTLINEPICS.splice(scope.list.OUTLINEPICS.length - 1, 1);
                                }
                                if (scope.list.OUTLINEPICS.length >= 10) {
                                    modalDialog.alertType('最多添加十张导图!', '', 'error', false);
                                    return;
                                }
                                if (scope.list.OUTLINEPICS.length < 10) {
                                    scope.list.OUTLINEPICS.push(newOutlinePic);
                                    if (scope.list.OUTLINEPICS.length < 10) {
                                        scope.list.OUTLINEPICS.push({
                                            APPFILE: '',
                                            APPDESC: '',
                                            PERPICURL: '',
                                        });
                                    }
                                }
                                modalDialog.alertType('设为导图成功', '', 'success', false);
                            }
                        });
                    },
                });
                popup.render();
                UE.plugins['addborder'] = function () {
                    var me = this;
                    //  创建一个改变图片边框的命令
                    me.commands['addborder'] = {
                        execCommand: function () {
                            //  获取当前选区
                            var range = me.selection.getRange();
                            //  选区没闭合的情况下操作
                            if (!range.collapsed) {
                                //  图片判断
                                var img = range.getClosedNode();
                                if (img && img.tagName == 'IMG') {
                                    //  点击切换图片边框
                                    img.style.border = img.style.borderWidth == '5px' ? '1px' : '5px solid red';
                                }
                            }
                        },
                    };
                };

                //  注册一个触发命令的事件，同学们可以在任意地放绑定触发此命令的事件
                ue.addListener('click', function (t, evt) {
                    if (!evt) {return;}
                    var html = '',
                        str = '';
                    var target = evt.target;
                    if (!$(target).hasClass('app_image')) {
                        return;
                    }
                    var range = ue.selection.getRange();
                    // if (!range.collapsed){
                    //     return;
                    // }
                    var img = range.getClosedNode();
                    if (img && img.tagName === 'IMG' && $(img).attr('videoid') === undefined && $(img).attr('audioid') === undefined) {
                        var dialogName = 'insertimageDialog';
                        if (img.className.indexOf('edui-faked-video') != -1 || img.className.indexOf('edui-upload-video') != -1) {
                            dialogName = 'insertvideoDialog';
                        }
                        if (img.className.indexOf('edui-faked-webapp') != -1) {
                            dialogName = 'webappDialog';
                        }
                        if (img.src.indexOf('http://api.map.baidu.com') != -1) {
                            dialogName = 'mapDialog';
                        }
                        if (img.className.indexOf('edui-faked-music') != -1) {
                            dialogName = 'musicDialog';
                        }
                        if (img.src.indexOf('http://maps.google.com/maps/api/staticmap') != -1) {
                            dialogName = 'gmapDialog';
                        }
                        if (img.getAttribute('anchorname')) {
                            dialogName = 'anchorDialog';
                            html = popup.formatHtml(
                                '<nobr>' +
                                ue.getLang('property') +
                                ': <span onclick=$$._onImgEditButtonClick("anchorDialog") class="edui-clickable">' +
                                editor.getLang('modify') +
                                '</span>&nbsp;&nbsp;' +
                                '<span onclick=$$._onRemoveButtonClick(\'anchor\') class="edui-clickable">' +
                                editor.getLang('delete') +
                                '</span></nobr>'
                            );
                        }
                        if (img.getAttribute('word_img')) {
                            //  todo 放到dialog去做查询
                            ue.word_img = [img.getAttribute('word_img')];
                            dialogName = 'wordimageDialog';
                        }
                        var isGif = editPictureService.isGif($(img).attr('src'));
                        str =
                            '<nobr>' +
                            '&nbsp;<span><input onchange=$$._enterEvent(this) onclick=this.focus();this.select(); type="text" style="width:40px" value="' +
                            img.clientWidth +
                            '">px</span>&nbsp;&nbsp;' +
                            '<span onclick=$$._onImgSetSize("small") class="edui-clickable smallpic">' +
                            '▪' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("middle") class="edui-clickable normal">' +
                            '■' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("big") class="edui-clickable bigpic">' +
                            '█' +
                            '</span>' +
                            '<span onclick=$$._onImgSetSize("original") class="edui-clickable ori-pic">' +
                            '原始大小' +
                            '</span> ' +
                            '<span onclick=$$._onImgSetSize("border") class="edui-clickable pic-border">' +
                            '边框' +
                            '</span> ';
                        if (!isGif) {
                            str += '<span onclick=$$._onImgclipping() class="edui-clickable pic-cut">' +
                                '编辑' +
                                '</span> ';
                        }
                        // '<span onclick="$$._onImgEditButtonClick(\'' +
                        // dialogName +
                        // '\');" class="edui-clickable pic-pro">' +
                        // '属性' +
                        // '</span> ' +
                        str += '<span onclick="$$._onSearchImg();" class="edui-clickable pic-cut">' +
                            '搜图' +
                            '</span> ' +
                            '<span onclick=$$._onImgDownOriginalGraph() class="edui-clickable pic-cut download-pic">' +
                            '下载原图' + '</span>';
                        //  网站渠道增加设为导图功能（编辑器中的图片可以直接设为导图）
                        if ((scope.type === 'website' || scope.draftType === 'video') && scope.type !== 'newmedia') {
                            str +=
                                '<span onclick="$$._setAsOutlinepics(\'' +
                                img.getAttribute('src') +
                                '\');" style="width:64px" class="edui-clickable pic-pro">' +
                                '设为导图' +
                                '</span>';
                        }
                        str += '</nobr>';
                        !html && (html = popup.formatHtml(str));
                        if (html) {
                            popup.getDom('content').innerHTML = html;
                            popup.anchorEl = img;
                            popup.showAnchor(popup.anchorEl);
                        } else {
                            popup.hide();
                        }
                    } else {
                    }
                });

                ue.addListener('afterscalehide', function () {
                    ue.focus();
                });
            },

            /**
             * [videoToolbar description] 点击播放的视频
             * @param {object} [ue] [description] 编辑器实例
             * @param {object} [scope] [description] 编辑器指令作用域
             * @return {[type]} [description]
             */
            videoPlayer: function (ue, scope) {
                var popup = new baidu.editor.ui.Popup({
                    editor: ue,
                    content: '',
                    className: 'edui-bubble',
                });
                popup.render();
                var promise;
                ue.addListener('click', function (t, causeByUi) {
                    var video = causeByUi.srcElement,
                        videoid = video.getAttribute('videoid'),
                        relationid = video.getAttribute('relationid'),
                        meiziid = video.getAttribute('meiziid'),
                        // imgurl = video.getAttribute('src'),
                        resourcetype = video.getAttribute('resourcetype'); // 用这个字段表示音视频类型
                    // audioid = video.getAttribute('audioid');
                    if (causeByUi.target.tagName === 'IMG' && videoid) {
                        if (promise) {
                            clearTimeout(promise);
                            promise = null;
                            return;
                        }
                        promise = setTimeout(function () {
                            if (!resourcetype || resourcetype === 'video') {
                                ueditorService.videoPlayer(videoid, 'video', relationid, meiziid).then(function (data) {
                                    if (data.videoid !== videoid) {
                                        $(video).attr('videoid', data.videoid);
                                    }
                                });
                            } else {
                                ueditorService.videoPlayer(videoid, 'audio', relationid, meiziid);
                            }
                            promise = null;
                        }, 300);
                    }
                });
            },

            /**
             * [videoToolbar_ description] 视频工具条
             * @param {object} [ue] [description] 编辑器实例
             * @return {[type]} [description]
             */
            videoToolbar_: function (ue) {
                var popup = new baidu.editor.ui.Popup({
                    editor: ue,
                    content: '',
                    className: 'edui-bubble',

                    /**
                     * [_editVideo description] 编辑视频
                     * @param   {[type]}  id       [id description]视频id
                     * @param   {[type]}  videoid  [videoid description]
                     * @param   {[type]}  docid    [docid description]
                     * @return  {[type]}           [return description]
                     */
                    _editVideo: function (id, videoid, docid) {
                        var video = ue.document.getElementById(id);
                        trsEditVideoService.trsEditVideoNew(videoid, 0, '', 'video/mp4').then(function (data) {
                            $(video).attr('src', data.URL);
                            $(video).attr('videoid', data.videoId);
                        });
                    },
                });
                popup.render();
                ue.addListener('mouseover', function (t, evt) {
                    var target = evt.target,
                        videoid = $(target).attr('videoid'),
                        docid = $(target).attr('docid');
                    if (target.tagName === 'IMG' && !!videoid) {
                        var id = 'video_' + parseInt(Math.random() * 100000);
                        target.setAttribute('id', id);
                        var str =
                            '<nobr><span onclick="$$._editVideo(\'' +
                            id +
                            "'," +
                            videoid +
                            ',' +
                            docid +
                            ');" class="edui-clickable pic-pro">编辑</span></nobr>';
                        var html = popup.formatHtml(str);
                        popup.getDom('content').innerHTML = html;
                        popup.anchorEl = target;
                        popup.showAnchor(popup.anchorEl);
                    } else {
                        popup.hide();
                    }
                });
            },

            /**
             * [appImagePlugin description] app图文补丁实例
             * @param  {[type]} ue [description] 编辑器实例
             * @param {[type]} [domUtils] [description]
             * @return {[type]}    [description]
             */
            appImagePlugin(ue, domUtils, media) {
                let mediaType = getMediaType(media);
                // let orgGetContent;
                reWriteGetContent(ue); /* 固定规则会为以后调整留下隐患，先注释掉 by Song */
                ue.addListener('click', (e) => {
                    let range = ue.selection.getRange();
                    fixSelectImagenote(range);
                });
                ue.ready(function () {
                    $(ue.body).bind('keydown', fixImageKeyDown);
                    $(ue.body).bind('keydown', fixImagenoteEnter);
                    $(ue.body).bind('keydown', fixBackspace);
                    $(ue.body).bind('click', fixImageRange);
                    domUtils.on(ue.body, 'dragstart', function (evt) { });
                });

                ue.addListener('selectionchange', (e) => {
                    fixImagenote(mediaType);
                });

                /**
                 * [fixImageRange 图片前后点击选中整个图片和图说区域]
                 *
                 * @param   {[type]}  e  [e description]
                 *
                 * @return  {[type]}     [return description]
                 */
                function fixImageRange(e) {
                    let target = e.target;
                    if ($(target).hasClass('app_image')) {
                        return;
                    }
                    let range = ue.selection.getRange();
                    if (isAfterImageRange(range, e, domUtils) || isBeforeImageRange(range, e, domUtils)) {
                        let startContainer = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement : range.startContainer;
                        let imageContainer = domUtils.findParent(startContainer, function (node) {
                            return $(node).hasClass('app_image_container');
                        });
                        if (imageContainer) {
                            selectNode(range, imageContainer);
                        }
                    }
                }

                /**
                 * [reWriteGetContent description] 重写获取正文方法
                 * @param   {[type]}  ue  [ue description]
                 * @return  {[type]}      [return description]
                 */
                function reWriteGetContent(ue) {
                    ue.__proto__.orgTheGetContent = angular.copy(ue.getContent);
                    ue.__proto__.getContent = function (cmd, fn, notSetCursor, ignoreBlank, formatter) {
                        let content = ue.orgTheGetContent(cmd, fn, notSetCursor, ignoreBlank, formatter);
                        content = content.replace(/<p><span type=\"imagenote\" class=\"imagenotePlace\">[^<]*<\/span><\/p>/gi, '');
                        content = content.replace(
                            /<p [^>]*type=("|')imagenote("|')[^>]*>[^\/]*请输入图片描述(.(?!\/p))*<\/p>/gi,
                            '<span type="imagenote" class="imagenotePlace"></span>' // 用这个标识解决图说的问题
                        ); // 升级版，兼容图说被修改样
                        content = content.replace(/<p><\/p>/gi, '');
                        return content;
                    };
                }

                /**
                 * [fixImageKeyDown description] 修复图片区域的键盘事件
                 * @param   {[type]}  e  [e description]
                 * @return  {[type]}     [return description]
                 */
                function fixImageKeyDown(e) {
                    if (e.keyCode == 8) {
                        return true;
                    }
                    let range = ue.selection.getRange();
                    if (e.keyCode == 46) {
                        if (isImageRangeSelected(range)) {
                            console.log('删除图片区域');
                            range.deleteContents();
                        }
                        if (isAboveImageRangeAndAtLast(range, e, domUtils)) {
                            return false;
                        }
                    }
                    let $contanier = $(range.startContainer);
                    if ($contanier && $contanier.length) {
                        let $img =
                            ($contanier[0].nextElementSibling && $contanier[0].nextElementSibling.tagName) == 'IMG'
                                ? $($contanier[0].nextElementSibling)
                                : ($contanier[0].previousElementSibling && $contanier[0].previousElementSibling.tagName) == 'IMG'
                                    ? $($contanier[0].previousElementSibling)
                                    : null;
                        if ($img && $img.attr && !$img.attr('videoid') && !$img.attr('audioid') && !$img.attr('emotion')) {
                            return false;
                        }
                    }

                    return true;
                }

                /**
                 * [fixImagenoteEnter description] 图说的回车事件
                 * @param  {[type]} e [description]
                 * @return {[type]}   [description]
                 */
                function fixImagenoteEnter(e) {
                    if (e.keyCode !== 13) {
                        return true;
                    }
                    let range = ue.selection.getRange();
                    if (isAfterImageRange(range, e, domUtils)) {
                        // TODO: 需要兼容图片选区闭合时前后回车的问题
                        let container = domUtils.findParent(range.startContainer, function (node) {
                            return $(node).hasClass('app_image_container');
                        });
                        let p = document.createElement('p');
                        p.innerHTML = '<br />';
                        domUtils.insertAfter(container, p);
                        return false;
                    }
                    if (isBeforeImageRange(range, e, domUtils)) {
                        let p = document.createElement('p');
                        p.innerHTML = '<br>';
                        let container = domUtils.findParent(range.startContainer, function (node) {
                            return $(node).hasClass('app_image_container');
                        });
                        let $container = $(container);
                        let parent = $container.parent();
                        if (parent[0].nodeName && parent[0].nodeName === 'BODY') {
                            $container.before(p);
                        } else {
                            $container.parent().before(p);
                        }
                        range.selectNode(p).select();
                        range.setStart(p, 0).setCursor();
                        return false;
                    }
                    if (range.startContainer === range.endContainer || range.startOffset + 1 === range.endOffset) {
                        if (isAllChildIsWarpAndNote(range) || isContainer(range)) {
                            let CursorAfter = range.endContainer;
                            // 处理撤销回来的图片选区变为body标签
                            if (range.startContainer.tagName === 'BODY') {
                                CursorAfter = $(range.startContainer).children()[range.startOffset];
                            }
                            range.setStartAfter(CursorAfter, 0);
                            range.setEndAfter(CursorAfter, 0);
                            range.setCursor();
                        }
                    } else if (isWarpAndNote(range)) {
                        let CursorAfter = $(range.endContainer).parents('.app_image_container')[0];
                        range.setStartAfter(CursorAfter, 0);
                        range.setEndAfter(CursorAfter, 0);
                        range.setCursor();
                    }
                    let $theP =
                        range.startContainer.tagName === 'P' && $(range.startContainer).attr('type') === 'imagenote'
                            ? $(range.startContainer)
                            : range.startContainer.parentElement && $(range.startContainer.parentElement).attr('type') == 'imagenote'
                                ? $(range.startContainer.parentElement)
                                : null;
                    if ($theP) {
                        let p = document.createElement('p');
                        p.innerHTML = '​<br>';
                        domUtils.insertAfter($theP[0], p);
                        range.selectNode(p).select();
                        range.setStart(p, 0).setCursor();
                        return false;
                    }
                    return true;
                }

                /**
                 * [fixBackspace description] 修复图说后面的文字退格bug
                 * @param  {[type]} e [description]
                 * @return {[type]}   [description]
                 */
                function fixBackspace(e) {
                    if (e.keyCode != 8) {
                        return true;
                    }
                    let range = ue.selection.getRange();
                    if (isEmptyImagenote(range)) {
                        return false;
                    }
                    if (isBeforeImageRange(range, e, domUtils)) {
                        let container = range.startContainer;
                        let topContainer = domUtils.findParent(container, function (node) {
                            return node.parentElement.tagName === 'BODY';
                        });
                        let prevContainer = $(topContainer).prev();
                        if (prevContainer && prevContainer.length) {
                            if (filterSpecialCharacters(prevContainer[0].textContent.trim()) === '') {
                                prevContainer.remove();
                            } else {
                                let node = prevContainer[0].lastChild;
                                range.selectNode(node).select();
                                range.setStart(node, 0).setCursor(true);
                            }
                            return false;
                        }
                        return true;
                    }
                    // 图说下面一行删除到图说时选中图片容器
                    if (
                        (isContainerAtLastInTagBefore(range) || isAfterContainer(range) || isAfterTagHaveNote(range)) &&
                        (isTagEmpty(range) || isCursorAtStart(range))
                    ) {
                        let node =
                            $(range.startContainer).prevAll('.app_image_container').length > 0
                                ? $(range.startContainer).prevAll('.app_image_container')[0]
                                : $(range.startContainer)
                                    .prevAll()
                                    .find('.app_image_container')[0];
                        selectNode(range, node);
                        return false;
                    }
                    if (
                        (isContainerAtLastInParentTagBefore(range) || isParentAfterContainer(range) || isParentAfterTagHaveNote(range)) &&
                        (isTagEmpty(range) || isCursorAtStart(range))
                    ) {
                        let node =
                            $(range.startContainer)
                                .parents()
                                .prevAll('.app_image_container').length > 0
                                ? $(range.startContainer)
                                    .parents()
                                    .prevAll('.app_image_container')[0]
                                : $(
                                    $(range.startContainer)
                                        .parents()
                                        .prevAll()[0]
                                ).find('.app_image_container')[0];
                        selectNode(range, node);
                        return false;
                    }

                    if (!range.collapsed || range.startOffset != 0 || range.endOffset != 0) {
                        return true;
                    }
                    let parentNode = range.startContainer.nodeName == '#text' ? range.startContainer.parentNode : range.startContainer;
                    if (!parentNode) {
                        return true;
                    }
                    let prevNode = parentNode.previousElementSibling;
                    if (!prevNode) {
                        return true;
                    }
                    let theClass = prevNode.getAttribute('class');
                    if (!theClass) {
                        return true;
                    }
                    // if (theClass.indexOf('imagenote') >= 0) {
                    if (theClass.indexOf('app_image_container') >= 0 || theClass.indexOf('imagenote') >= 0) {
                        return false;
                    }
                }

                /**
                 * [fixImagenote description]
                 * @param   {[type]}  mediaType  [mediaType description]
                 * @return  {[type]}             [return description]
                 */
                function fixImagenote(mediaType) {
                    try {
                        // 处理修改图说样式但是没有给图说赋值的问题
                        let $body = $(ue.body);
                        let $images = $body.find('img');
                        let flag = false;
                        $images.each(function () {
                            let $image = $(this);
                            if ($image.attr('videoid') == 0) {
                                $image.removeAttr('videoid');
                            }
                            if ($image.attr('videoid') || $image.attr('audioid') || $image.attr('emotion') || isAlreadyDeal($image, domUtils) || $image.attr('wordimgid')) {
                                if (isAlreadyDeal($image, domUtils)) {
                                    let appImageWrap = domUtils.findParent($image[0], function (node) {
                                        return $(node).hasClass('app_image_wrap');
                                    });
                                    if (appImageWrap && ($(appImageWrap).css('text-align') === 'start' || $(appImageWrap).css('text-align') === 'end')) {
                                        $(appImageWrap).css('text-align', 'center');
                                    }
                                    let appImageConter = domUtils.findParent(appImageWrap, function (node) {
                                        return $(node).hasClass('app_image_container');
                                    });
                                    if (appImageConter) {
                                        $(appImageConter).css('text-align', $(appImageWrap).css('text-align'));
                                    }
                                    if ($(appImageWrap).css('text-align') === 'right') {
                                        $(appImageWrap).next().css('marginRight', '0');
                                        $(appImageWrap).next().css('marginLeft', 'auto');
                                    }
                                    if ($(appImageWrap).css('text-align') === 'left') {
                                        $(appImageWrap).next().css('marginLeft', '0');
                                        $(appImageWrap).next().css('marginRight', 'auto');
                                    }
                                    if ($(appImageWrap).css('text-align') === 'center') {
                                        $(appImageWrap).next().css('marginLeft', 'auto');
                                        $(appImageWrap).next().css('marginRight', 'auto');
                                    }

                                }
                                if ($image.attr('videoid') || $image.attr('audioid')) {
                                    if ($image.parent().css('text-align') !== 'center') {
                                        $image.parent().css('text-align', 'center');
                                    }
                                }
                                return;
                            }
                            flag = true;
                            let imagenote;
                            let imgNextNode = getNextNode($image[0], domUtils);
                            if ($(imgNextNode).hasClass('imagenote')) {
                                imagenote = angular.copy(imgNextNode);
                            }
                            $image.css({
                                clear: 'both',
                                maxWidth: 640,
                            });
                            $image.attr({
                                type: 'app_image',
                                class: 'app_image',
                            });
                            let imgWrap = $image.parent();
                            if (imgWrap && imgWrap.length && imgWrap[0].tagName === 'A') {
                                if (!imgWrap.parent().hasClass('app_image_wrap')) {
                                    imgWrap.wrap('<p class="app_image_wrap" type="app_image_wrap"></p>');
                                    if (imagenote) {
                                        setStyleForImageNote(imagenote);
                                        $(imagenote).insertAfter(imgWrap.parent());
                                    }
                                    if (imgWrap.parent().css('text-align') === 'start' || imgWrap.parent().css('text-align') === 'end') {
                                        imgWrap.parent().css('text-align', 'center');
                                    }
                                }
                            } else {
                                if (!$image.parent().hasClass('app_image_wrap')) {
                                    $image.wrap('<p class="app_image_wrap" type="app_image_wrap"></p>');
                                    if (imagenote) {
                                        setStyleForImageNote(imagenote);
                                        $(imagenote).insertAfter($image.parent());
                                    }
                                    if ($image.parent().css('text-align') === 'start' || $image.parent().css('text-align') === 'end') {
                                        $image.parent().css('text-align', 'center');
                                    }
                                }
                            }
                        });
                        // 图片和图说之间的相关绑定操作 add by Song, jira:XJRB-1826
                        // 对已添加的图说和图片结构上的调整要恢复，图说的样式修改要恢复
                        // 修正从HTML模式回到编辑模式后，dom查找实际上基于上一次contentChange事件触发时的内容来查找的
                        let $imageContainers = $body.find('.app_image_container');
                        $imageContainers.each(function () {
                            let $imageContainer = $(this);
                            let $imageApp = $imageContainer.find('img[type="app_image"]');
                            if ($imageApp.length <= 0) {
                                // 兼容空的图片wrap
                                if ($imageContainer[0].tagName === 'BODY') {
                                    return;
                                }
                                $imageContainer.remove();
                            }
                        });
                        let $imagesWrap = $body.find('.app_image_wrap');
                        $imagesWrap.each(function () {
                            let $imageWrap = $(this),
                                $imageApp = $imageWrap.find('img[type="app_image"]');
                            let $imageContainer = $imageWrap.parent();
                            if ($imageApp.length <= 0) {
                                // 兼容空的图片wrap
                                $imageWrap.removeClass('app_image_wrap');
                                if ($imageWrap.attr('type') === 'app_image_wrap') {
                                    $imageWrap.removeAttr('type');
                                }
                                if ($imageWrap.parent()[0].tagName === 'BODY') {
                                    return;
                                }
                                if (filterSpecialCharacters($imageWrap[0].textContent) !== '') {
                                    return;
                                }
                                $imageWrap.remove();
                                return;
                            }
                            if (!$imageContainer.hasClass('app_image_container')) {
                                let isHaveImagenote = $imageWrap.next().hasClass('imagenote');
                                let $imagenote;
                                if (isHaveImagenote) {
                                    $imagenote = $imageWrap.next();
                                }
                                $imageWrap.wrap('<div class="app_image_container" type="app_image_container"></div>');
                                if ($imagenote && $imagenote.length) {
                                    $imagenote.insertAfter($imageWrap[0]);
                                }
                            }
                            flag = true;
                            let imageSrc = $imageApp.attr('src'),
                                imageMeiziid = $imageApp.attr('meiziid'),
                                imageSource = $imageApp.attr('imageSource');
                            $imageApp.removeAttr('uploadpic');
                            if (isOutLinkPic(imageSrc)) {
                                let url = imageSrc;
                                let resourcetype = $imageApp.attr('resourcetype');
                                if (resourcetype && (resourcetype === 'video' || resourcetype === 'audio')) {
                                    return;
                                }
                                if (isPicDownloading(url)) {
                                    return;
                                }
                                $imageApp.attr('src', './static/jz.gif');
                                $imageApp.attr('_src', './static/jz.gif');
                                downloadPic(url, mediaType).then(
                                    function (newUrl) {
                                        imageSrc = newUrl;
                                        $imageWrap.find('img').attr('src', imageSrc);
                                        $imageWrap.find('img').attr('_src', imageSrc);
                                    },
                                    function (msg) {
                                        if ($imageWrap.find('img')[0].src !== './static/picture_default.jpg') {
                                            let failPictureUniqueId = getUniqueId(url);
                                            imageSrc = './static/picture_default.jpg';
                                            $imageWrap.find('img')[0].src = imageSrc;
                                            $imageWrap.find('img').attr('_src', imageSrc);
                                            $imageWrap.find('img').attr('failid', failPictureUniqueId);
                                            let item = $imageWrap.find('img')[0];
                                            $(item).css('border', '2px solid blue');
                                            let $note = $(
                                                '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red;"><img width="20" height="20" src="./static/download_fail.png">图片自动下载失败，请手动上传</p>'
                                            );
                                            let topCon;
                                            let topConForWX = domUtils.findParent(item, function (node) {
                                                return $(node).hasClass('_135editor') || $(node).hasClass('app_image_container');
                                            });
                                            if (topConForWX) {
                                                topCon = topConForWX;
                                            } else {
                                                topCon = $(item).parent()[0];
                                            }
                                            $note.insertAfter($(topCon));
                                        }
                                    }
                                );
                            } else {
                                $imageWrap.find('img')[0].src = imageSrc;
                            }
                            // TODO：检测图片：添加图片未添加图说，进行添加
                            if (!$imageWrap.next().hasClass('imagenote') && imageSrc.indexOf('./static/') === -1) {
                                let $note = $("<p type='imagenote' class='imagenote'>请输入图片描述</p>");
                                setStyleForImageNote($note[0]);
                                $note.attr('imagekey', imageMeiziid || imageSrc);
                                $note.insertAfter($imageWrap);
                            }
                        });
                        let $imagenotes = $body.find('*[type="imagenote"]');
                        $imagenotes.each(function () {
                            flag = true;
                            let $imagenote = $(this);
                            let imagenote = this;
                            // 检测图说：删除图片未删除的图说，进行清除
                            if (!$imagenote.prev().hasClass('app_image_wrap')) {
                                $imagenote.remove();
                                return;
                            }
                            if (imagenote && !$(imagenote).attr('prepaste')) {
                                $(imagenote).attr('prepaste', 'true');
                                domUtils.on(imagenote, 'paste', (e) => {
                                    fixImagenotePaste(imagenote, e, ue);
                                });
                            }
                            let $imageApp = $imagenote.prev().find('img[type="app_image"]');
                            let imgMaxWidth = parseInt($imageApp.css('max-width'));
                            let imgWidth = parseInt($imageApp[0].width) === 0 ? 640 : parseInt($imageApp[0].width);
                            let imgnoteWidth = Math.min(imgWidth, imgMaxWidth) + 'px';
                            // 图说
                            $imagenote.css('width', 'auto');
                            $imagenote.css('max-width', imgnoteWidth);
                            if ($imagenote.find('strong').length > 0 || $imagenote.find('em').length > 0 || ($imagenote.find('span').length > 0 && !$imagenote.find('span').hasClass('trasScale'))) {
                                $imagenote.html($imagenote.text()); // 此方法会改变光标位置
                            }
                        });
                        if (flag) {
                            // delayFireEvent('contentchange');
                        }
                    } catch (e) {
                        console.log(e);
                        console.log('图说修复有异常');
                    }
                }

                /**
                 * [fixSelectImagenote description] 选区选中图说功能补充
                 * @param {object} [range] [description] 被选中选区
                 * @return {[type]} [description]
                 */
                function fixSelectImagenote(range) {
                    try {
                        let $startContainer = $(range.startContainer.parentElement);
                        let $endContainer = $(range.endContainer.parentElement);
                        let $imgnote =
                            $startContainer.attr('type') === 'imagenote'
                                ? $startContainer
                                : $endContainer.attr('type') === 'imagenote'
                                    ? $endContainer
                                    : null;
                        //  事先需要检查并补充所有没有文字的图说，补充文字为“请输入图片描述”
                        let $body = $(ue.body);
                        let $imgnotes = $body.find("p[type='imagenote']");
                        let flag = false;
                        $imgnotes.each(function (index) {
                            let $imgnote = $(this);
                            if (
                                $imgnote
                                    .text()
                                    .replace(/ /g, '')
                                    .replace(/&nbsp;/g, '')
                                    .replace(/​/g, '') === ''
                            ) {
                                flag = true;
                                $imgnote.html('请输入图片描述');
                            }
                        });
                        if ($imgnote && $imgnote.text().indexOf('请输入图片描述') >= 0) {
                            //  当选区包含图说是，若图说中的字符包含“请输入图片描述”时，需要清除图说中的文字   模拟placeholder功能
                            $imgnote.html('');
                        }
                        // delayFireEvent('contentchange');
                    } catch (e) {
                        //  console.log('图说选区修复异常');
                    }
                }

                let promise;

                /**
                 * [delayFireEvent description]
                 * @param   {[type]}  type  [type description]
                 * @return  {[type]}        [return description]
                 */
                function delayFireEvent(type) {
                    if (promise) {
                        clearTimeout(promise);
                        promise = null;
                    }
                    promise = setTimeout(() => {
                        ue.fireEvent(type);
                    }, 5000);
                }
            },

            /**
             * [appAcorAd description] app的活动或广告
             * @param   {[type]}  ue  [ue description]
             * @return  {[type]}      [return description]
             */
            appAcorAd(ue) {
                ue.addListener('click', (e, causeByUi) => {
                    var acorAd = causeByUi.srcElement;
                    var feature = acorAd.getAttribute('feature');
                    if (causeByUi.target.tagName === 'IMG' && feature === 'advertising') {
                        window.open(acorAd.getAttribute('target'));
                    }
                    // let range = ue.selection.getRange();
                    // fixSelectImagenote(range);
                });
            },

            /**
             * [ue 编辑器利用空格进行缩进]
             *
             * @param   {[type]}  ue        [ue 编辑器实例]
             * @param   {[type]}  domUtils  [domUtils description]
             *
             * @return  {[type]}            [return description]
             */
            spaceIndent: function (ue, domUtils) {
                ue.ready(function () {
                    $rootScope.spaceForIndent = 0;
                    $(ue.body).bind('keyup', spaceIndent);
                });

                /**
                 * [spaceIndent 空格缩进]
                 *
                 * @param   {[type]}  event  [event description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function spaceIndent(event) {
                    let keyCode = event.keyCode || event.which;
                    if (keyCode === 32) {
                        let range = ue.selection.getRange();
                        if (isIndentSpace(range)) {
                            let parentNode = range.startContainer.nodeName == '#text' ? range.startContainer.parentNode : range.startContainer;
                            if (!parentNode) {
                                return true;
                            }
                            let reg = /\u0020/gi;
                            let content = parentNode.innerHTML;
                            if (reg.test(content) || content.charAt(0) === '&') {
                                ue.document.execCommand('delete');
                                ue.execCommand('insertHtml', '\u3000');
                            }
                            return false;
                        }
                    }
                    return true;
                }

                /**
                 * [isIndentSpace 是否为行首缩进空格]
                 *
                 * @param   {[type]}  range  [range 当前光标所在选区托蓝]
                 *
                 * @return  {[type]}         [return description]
                 */
                function isIndentSpace(range) {
                    let startOffset = range.startOffset;
                    let endOffset = range.endOffset;
                    let wholeText = range.startContainer.data;
                    let nodeType = range.startContainer.nodeType;
                    let wholeLength = wholeText.length;
                    let plainTextLength = wholeText.replace(/^\s+/gi, '').replace(/\s+$/gi, '').length;
                    let indentLength = wholeLength - plainTextLength;
                    return (
                        range.collapsed &&
                        nodeType === 3 &&
                        startOffset === endOffset &&
                        range.startContainer == range.endContainer &&
                        endOffset <= indentLength
                    );
                }
            },

            /**
             * [ue description] 点击编辑器HTML源码的方法
             * @param   {[object]}  ue [ue description] 编辑器对象
             * @return  {[undefined]}  [return description]
             */
            clickSource: function (ue) {
                ue.addListener('afterSetContent', (e) => {
                    if (ue.sourceMode) {
                        let $uebody = $(ue.body);
                        $uebody.html(ueditorService.filterXSS($uebody.html()));
                    }
                    fixAppHtmlTag(ue);
                    previewService.drawVideoMark(true, true);
                });
            },

            /**
             * [ue 修复图说删除后图片与正文结构错乱的问题]
             *
             * @param   {[type]}  ue  [ue description]
             *
             * @return  {[type]}      [return description]
             */
            fixContentInImageWrap: function (ue) {
                ue.addListener('selectionchange', (e) => {
                    var ragne = ue.selection.getRange();
                    if (!ragne.collapsed) {
                        return;
                    }
                    fixImgInPragraph(ue);
                    fixNoWidthImg(ue);
                    removeFailTips(ue);
                    removeFailImg(ue);
                });
            },

            /**
             * [ue 预下载站外图片]
             *
             * @param   {[type]}  ue        [ue description]
             * @param   {[type]}  domUtils  [domUtils description]
             * @param   {[type]}  media  [domUtils description]
             *
             * @return  {[type]}            [return description]
             */
            outlinkPicDownload: function (ue, domUtils, media) {
                let mediaType = getMediaType(media);
                let promise;
                ue.addListener('contentChange', (type, flag) => {
                    if ($(ue.body).html() === '' || $(ue.body).html() === '<p>​<br></p>') {
                        return;
                    }
                    fix135quot(ue);
                    if (flag || this.isDownloading) {
                        return;
                    } //  使用flag解决多次循环触发
                    if (promise) {
                        clearTimeout(promise);
                        promise = null;
                    }
                    promise = setTimeout(() => {
                        this.isDownloading = true;
                        // 1.统计普通图片数量
                        let $ueBody = $(ue.body);
                        let $imgs = $ueBody.find('img');
                        // 2.统计背景图片数量
                        let waitDownladPics = [];
                        // 3. 统计需要下载的普通图片的数量
                        let $newImages = getNewImages($imgs);
                        if ($newImages.length) {
                            $newImages.forEach((img) => {
                                $(img).attr('oldSrc', $(img).attr('src'));
                                let item = {
                                    originSrc: $(img).attr('src'),
                                    type: 'normal'
                                };
                                waitDownladPics.push(item);
                            });
                        }
                        let htmlContent = angular.copy($(ue.body).html());
                        let regExp = /(background|background\-image)\s*\:\s*url\s*\(\s*(('|"|&quot;)?)\s*(\/\/|http\:\/\/|https\:\/\/)([^\s]+)\2\s*\)/g; //  匹配正文中的background
                        var backgroundGather = htmlContent.match(regExp);
                        // 4. 统计需要下载的背景图片的数量
                        if (backgroundGather) {
                            for (let i = 0; i < backgroundGather.length; i++) {
                                let item = backgroundGather[i];
                                let imgSrc = getBackgroundImgSrc(item);
                                if (isOutLinkPic(imgSrc)) {
                                    let item = {
                                        originSrc: imgSrc,
                                        type: 'background'
                                    };
                                    waitDownladPics.push(item);
                                }
                            }
                        }

                        // 5. 统计总数
                        if (waitDownladPics.length === 0) {
                            this.isDownloading = false;
                            return;
                        }
                        const $failImages = [];
                        // 6. 下载替换图片
                        replaceImages(ue, waitDownladPics, htmlContent, mediaType, $failImages).then((result) => {
                            if (result.html !== '') {
                                let body = document.createElement('div');
                                $(body).html(result.html);
                                let $images = $(body).find('img');
                                $images.each((index, item) => {
                                    let url = $(item).attr('oldSrc') || '';
                                    if ($failImages.length && isFailImg($failImages, url)) {
                                        let url = $(item).attr('_src');
                                        let failPictureUniqueId = getUniqueId(url);
                                        $(item).attr({
                                            src: './static/picture_default.jpg',
                                            oldimg: true,
                                            failId: failPictureUniqueId,
                                        });
                                        $(item).css('border', '2px solid blue');
                                        let failImg = getFailImg($failImages, url);
                                        let $note = $(
                                            '<p class="image_fail_tip" style="color:red;" id="' + failPictureUniqueId + '"><img width="20" height="20" src="./static/download_fail.png" data-oldsrc="' +
                                            url +
                                            '">' + failImg.msg + '</p>'
                                        );
                                        let topCon;
                                        let topConForWX = domUtils.findParent($(item)[0], function (node) {
                                            return $(node).hasClass('_135editor');
                                        });
                                        if (topConForWX) {
                                            topCon = topConForWX;
                                        } else {
                                            topCon = $(item).parent()[0];
                                        }
                                        if (!$(topCon).next().hasClass('image_fail_tip')) {
                                            $note.insertAfter($(topCon));
                                        }
                                    } else {
                                        $(item).attr({
                                            _src: $(item).attr('src'),
                                            oldimg: true,
                                        });
                                        if ($(item).attr('uploadpic')) {
                                            $(item).removeAttr('uploadpic');
                                        }
                                    }
                                    $(item).removeAttr('oldsrc');
                                });
                                if ($failImages.length) {
                                    if (!$('.image-upload-error-info').length) {
                                        let note = '<p class="image-upload-error-info" style="position:absolute; top:75px; background:#f5f5b2; z-index:1000; width:100%; height:40px; line-height:40px; padding-left:20px;">有' + $failImages.length + '张站外图片下载失败，请删除后手动上传</p>';
                                        $(note).prependTo($('.edui-editor-toolbarbox', window.parent.document));
                                    } else {
                                        $('.image-upload-error-info').text('有' + $failImages.length + '张站外图片下载失败，请删除后手动上传');
                                    }
                                }
                                ue.setContent($(body).html());
                                this.isDownloading = false;
                                ue.fireEvent('contentchange', false);
                            }
                        });
                    }, 2000);
                });
                ue.addListener('selectionchange', function () {
                    fixRotatePTag(ue);
                    fixBackGroundImg(ue);
                });

            },

            disableImagenote: function (ue, isFusion) {
                ue.addListener('contentchange', function () {
                    let $uebody = $(ue.body);
                    let $imagenotes = $uebody.find('*[type="imagenote"]');
                    $imagenotes.each(function () {
                        let $imagenote = $(this);
                        if (isFusion && $imagenote.text() !== '') {
                            let p = document.createElement('p');
                            $(p).html($imagenote.html());
                            $(p).css('color', '#0000CD');
                            $(p).insertAfter($imagenote);
                        }
                        $imagenote.remove();
                    });
                });
            },

            /**
             * [replaceWeixinVideo 微信渠道外链视频转换或提示]
             *
             * @param   {[type]}  ue        [ue description]
             * @param   {[type]}  domUtils  [domUtils description]
             *
             * @return  {[type]}            [return description]
             */
            replaceWeixinVideo: function (ue, domUtils) {
                ue.addListener('selectionchange', function () {
                    replaceWeixinVideoAndAudio(ue);
                });
            },

            /**
             * [addContentBeforeHtml 添加默认稿件作者]
             * @param   {[type]}  ue  [ue description]
             * @return  {[type]}      [return description]
             */
            addContentBeforeHtml: function (ue) {
            },

            /**
             * [addOriginBeforeHtml description] 给编辑器开头插入标语
             * @param   {[object]}  ue  [ue description] 编辑器实例
             * @return  {[undefined]}   [return description]
             */
            // addOriginBeforeHtml: function (ue) {
            //     getDraftStatus().then((draftInfo) => {
            //         if (draftInfo.doctype === '新闻' && draftInfo.trench === 'I我') {
            //             editingCenterService.getDefaultTplForNews().then((data) => {
            //                 let content = data.NEWS_MESSAGE_HEADER || '';
            //                 const date = new Date().toLocaleString('zh', { 'month': 'short', 'day': 'numeric' });
            //                 const curUserName = $sessionStorage.get('curUserInfo') ? $sessionStorage.get('curUserInfo').TRUENAME : '';
            //                 content = '\u3000\u3000' + content
            //                     .replace('${current_date}', date)
            //                     .replace('${current_user}', curUserName);
            //                 addContent(ue, 'before', 'origin-flag', content);
            //             });
            //         }
            //     });
            // },

            /**
             * [addOriginBeforeHtml description]
             * @param   {[object]}  ue  [ue description] 编辑器实例
             * @return  {[type]}        [return description]
             */
            // addfinishAfterHtml: function(ue){
            //     getDraftStatus().then((draftInfo) => {
            //         if (draftInfo.doctype === '新闻' && draftInfo.trench === 'I我') {
            //             let content = '（完）';
            //             addContent(ue, 'after', 'finish-flag', content);
            //         }
            //     });
            // },

            fixPasteFromMicoWord(ue){
                ue.addListener('afterpaste', function () {
                    let $images = $(ue.body).find('img');
                    if ($images.length) {
                        $images.each(function(index, item) {
                            let $img = $(item);
                            if (isImgFromWordPaste($img)) {
                                localImgFailTip($img, index);
                            }
                        });
                    }
                });
            }
        };

        /**
         * [getDraftStatus description]
         * @return  {[type]}  [return description]
         */
        // function getDraftStatus() {
        //     let defer = $q.defer();
        //     editingCenterService.isXJRB().then(() => {
        //         const doctype = editingCenterService.getDocType();
        //         const editMode = editingCenterService.getEditMode();
        //         const mediaType = editingCenterService.getEditPageMediaType();
        //         const trench = editingCenterService.getMediaName(mediaType);
        //         defer.resolve({
        //             doctype: doctype,
        //             editMode: editMode,
        //             trench: trench,
        //         });
        //     });
        //     return defer.promise;
        // }


        /**
         * [addContent 在正文前面或后面添加内容]
         * @param   {[type]}  ue         [ue description]
         * @param   {[type]}  type       [type description]
         * @param   {[type]}  className  [className description]
         * @param   {[type]}  content    [content description]
         * @return  {[type]}             [return description]
         */
        function addContent(ue, type, className, content) {
            let htmlContent = ue.getContent();
            let reg = new RegExp(className);
            if (reg.test(htmlContent)) {
                return;
            }
            var htmlTemplate = ['<p>', '<span class="' + className + '">' + content + '</span>', '</p>'].join('');
            if (type === 'before') {
                htmlContent = htmlTemplate + htmlContent;
            } else {
                htmlContent += htmlTemplate;
            }
            ue.execCommand('cleardoc');
            ue.execCommand('insertHtml', htmlContent);
            ue.fireEvent('contentchange');
        }

        /**
         * [fix135quot 修复135样式中的错误的引号]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fix135quot(ue) {
            var htmlContent = angular.copy($(ue.body).html());
            const styleReg = /style=\"[^"]*width:\s*("|'|&quot;).*\"/gim;
            var $styles = htmlContent.match(styleReg);
            if (!$styles) {
                return;
            }
            $styles.forEach(function (item, index) {
                if (item.indexOf('width:') > -1) {
                    let newStyle = item.replace(/width:\s*("|'|&quot;)([^"]*)\1/gi, 'width: $2');
                    htmlContent = htmlContent.replace($styles[index], newStyle);
                }
            });
            ue.setContent(htmlContent);
        }

        /**
         * [isFailImg 是否为失败的图片]
         *
         * @param   {[type]}  $failImages  [$failImages description]
         * @param   {[type]}  url          [url description]
         *
         * @return  {[type]}               [return description]
         */
        function isFailImg($failImages, url) {
            let isFailImg = false;
            for (let i = 0; i < $failImages.length; i++) {
                if ($failImages[i].url === url) {
                    isFailImg = true;
                }
            }
            return isFailImg;
        }

        /**
         * [isFailImg 是否为失败的图片]
         *
         * @param   {[type]}  $failImages  [$failImages description]
         * @param   {[type]}  url          [url description]
         *
         * @return  {[type]}               [return description]
         */
        function getFailImg($failImages, url) {
            let img = null;
            for (let i = 0; i < $failImages.length; i++) {
                if ($failImages[i].url === url) {
                    img = $failImages[i];
                }
            }
            return img;
        }

        /**
         * [getNewImages 获取需要下载的图片]
         *
         * @param   {[type]}  $imgs  [$imgs description]
         *
         * @return  {[type]}         [return description]
         */
        function getNewImages($imgs) {
            let $newImages = [];
            if ($imgs.length) {
                $imgs.each(function () {
                    let $img = $(this);
                    if ($img.attr('data-src')) {
                        $img.removeAttr('data-src');
                    }
                    let parentWidth = $img.parent().width();
                    let imgWidth = $img.width();
                    if (imgWidth > parentWidth) {
                        parentWidth = parentWidth === 0 ? '100%' : parentWidth;
                        $img.css('max-width', parentWidth + 'px');
                    }
                    if (!$img.attr('oldimg') && !$img.attr('videoid') && isOutLinkPic($img.attr('src')) && !isPicDownloading($img.attr('src'))) {
                        $newImages.push($img);
                    }
                });
            }
            return $newImages;
        }

        /**
         * [filterSpecialCharacters 过滤特殊字符]
         *
         * @param   {[type]}  str  [str description]
         *
         * @return  {[type]}       [return description]
         */
        function filterSpecialCharacters(str) {
            let rs = str.replace(/\u200b/g, '').replace(/\u200c/g, '');
            return rs;
        }

        /**
         * [fixAppHtmlTag 兼容移动端的HTML标签格式]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fixAppHtmlTag(ue) {
            let $uebody = $(ue.body);
            fixAppHtmlForAndroid($uebody);
            $uebody.html(ueditorService.fixAppHtmlTag($uebody.html()));
        }

        /**
         * [fixAppHtmlForAndroid 兼容安卓采编换行格式]
         *
         * @param   {[type]}  $uebody  [$uebody description]
         *
         * @return  {[type]}           [return description]
         */
        function fixAppHtmlForAndroid($uebody) {
            let $nodes = $uebody.contents().filter(function () {
                return this.nodeName.toLowerCase() === 'br' && $(this).parent()[0].tagName === 'BODY';
            });
            $nodes.each(function () {
                let $node = $(this);
                $node.remove();
            });
            let $textNodesNoParent = $uebody.contents().filter(function () {
                return this.nodeType === 3 && $(this).parent()[0].tagName === 'BODY';
            });
            $textNodesNoParent.each(function () {
                let $item = $(this);
                $item.wrap('<p></p>');
            });
        }

        /**
         * [isImageRangeSelect 当前选中的是否为图片区域]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isImageRangeSelected(range) {
            if (!range.collapsed) {
                if (range.startContainer === range.endContainer || isWarpAndNote(range)) {
                    if (isAllChildIsWarpAndNote(range) || isContainer(range)) {
                        return true;
                    }
                }
            }
            return false;
        }

        /**
         * [isAfterImageRange 光标是否处于图片区域后面]
         *
         * @param   {[type]}  range  [range description]
         * @param   {[type]}  evt  [range description]
         * @param   {[type]}  domUtils  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isAfterImageRange(range, evt, domUtils) {
            // if (!range.collapsed) {
            //     return false;
            // }
            let startContainer = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement : range.startContainer;
            let endContainer = range.endContainer.nodeName === '#text' ? range.endContainer.parentElement : range.endContainer;
            if (
                startContainer == endContainer &&
                ($(startContainer).hasClass('app_image_wrap') ||
                    $(startContainer)
                        .parent()
                        .hasClass('app_image_wrap'))
            ) {
                if (evt.type === 'click') {
                    let currentX = evt.clientX;
                    let imgs = $(startContainer).find('img');
                    if (imgs && imgs.length) {
                        let img = imgs[0];
                        let imgX = domUtils.getXY(img).x;
                        if (currentX > imgX) {
                            return true;
                        }
                    }
                }
                if (evt.type === 'keydown') {
                    if (range.endOffset > 0) {
                        return true;
                    }
                }
            }
            return false;
        }

        /**
         * [isBeforeImageRange 光标是否处于图片区域前面]
         *
         * @param   {[type]}  range  [range description]
         * @param   {[type]}  evt  [range description]
         * @param   {[type]}  domUtils  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isBeforeImageRange(range, evt, domUtils) {
            // if (!range.collapsed) {
            //     return false;
            // }
            let startContainer = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement : range.startContainer;
            let endContainer = range.endContainer.nodeName === '#text' ? range.endContainer.parentElement : range.endContainer;
            if (
                startContainer == endContainer &&
                ($(startContainer).hasClass('app_image_wrap') ||
                    $(startContainer)
                        .parent()
                        .hasClass('app_image_wrap')) &&
                range.startOffset === 0
            ) {
                if (evt.type === 'click') {
                    let currentX = evt.clientX;
                    let imgs = $(startContainer).find('img');
                    if (imgs && imgs.length) {
                        let img = imgs[0];
                        let imgX = domUtils.getXY(img).x;
                        if (currentX < imgX) {
                            return true;
                        }
                    }
                }
                if (evt.type === 'keydown') {
                    if (range.endOffset < 1) {
                        return true;
                    }
                }
            }
            return false;
        }

        /**
         * [isAboveImageRangeAndAtLast 是否在图片区域上方并且是行尾]
         *
         * @param   {[type]}  range     [range description]
         * @param   {[type]}  evt       [evt description]
         * @param   {[type]}  domUtils  [domUtils description]
         *
         * @return  {[type]}            [return description]
         */
        function isAboveImageRangeAndAtLast(range, evt, domUtils) {
            let container = range.startContainer;
            if (container.nodeName !== '#text') {
                return false;
            }
            if (range.endOffset !== container.textContent.length) {
                return false;
            }
            let nextNode = domUtils.getNextDomNode(container);
            if (
                $(nextNode)
                    .html()
                    .indexOf('app_image_container') > 0
            ) {
                return true;
            }

            return false;
        }

        /**
         * [isAllChildIsWarpAndNote 容器的是否只包含图片与图说]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isAllChildIsWarpAndNote(range) {
            return (
                $(range.startContainer).children().length > 0 &&
                $(range.startContainer).find('.app_image_container').length + $(range.startContainer).find('.imagenotePlace').length ===
                $(range.startContainer).children().length
            );
        }

        /**
         * [isContainer 是否图片区域外层容器]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isContainer(range) {
            let tag = range.startContainer.tagName === 'BODY' ? $(range.startContainer).children()[range.startOffset] : range.startContainer;
            return $(tag).hasClass('app_image_container');
        }

        /**
         * [isWarpAndNote 区域是否开始于图片结束与图说]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isWarpAndNote(range) {
            return (
                $(range.startContainer).hasClass('app_image_wrap') &&
                ($(range.endContainer).hasClass('imagenote') ||
                    $(range.endContainer)
                        .parent()
                        .hasClass('imagenote'))
            );
        }

        /**
         * [isContainerAtLastInTagBefore 是否为图说下面一行]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isContainerAtLastInTagBefore(range) {
            let childArr = $(range.startContainer)
                .prev()
                .children();
            return childArr.length && $(childArr[childArr.length - 1]).hasClass('app_image_container');
        }

        /**
         * [isAfterContainer 是否在图说区域之后]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isAfterContainer(range) {
            return $(range.startContainer)
                .prev()
                .hasClass('app_image_container');
        }

        /**
         * [isAfterTagHaveNote 是否在包含图说的容器下方]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isAfterTagHaveNote(range) {
            return (
                $(range.startContainer)
                    .prev()
                    .find('[type="imagenote"]').length > 0
            );
        }

        /**
         * [isTagEmpty 选区起点容器的内容是否为空]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isTagEmpty(range) {
            return range.startContainer.textContent === '​' || range.startContainer.textContent === '';
        }

        /**
         * [isCursorAtStart 是否闭合在行首]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isCursorAtStart(range) {
            return (
                (range.startOffset === 0 && range.endOffset === 0) ||
                (range.startOffset === 1 && range.endOffset === 1 && range.startContainer.textContent.indexOf('​') > -1)
            );
        }

        /**
         * [isContainerAtLastInParentTagBefore 判断选区起点容器是否在图片容器之前]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isContainerAtLastInParentTagBefore(range) {
            let childArr = $(
                $(range.startContainer)
                    .parents()
                    .prev()[0]
            ).children();
            return childArr.length && $(childArr[childArr.length - 1]).hasClass('app_image_container');
        }

        /**
         * [isParentAfterContainer 选区起点容器是否在图片区域容器后面]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isParentAfterContainer(range) {
            return $(range.startContainer)
                .parents()
                .prev()
                .hasClass('app_image_container');
        }

        /**
         * [isParentAfterTagHaveNote 选区起点容器的父节点是否在图说节点之后]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isParentAfterTagHaveNote(range) {
            return (
                $(range.startContainer)
                    .parents()
                    .prev()
                    .find('[type="imagenote"]').length > 0
            );
        }

        /**
         * [isEmptyImagenote 光标出于图说中并且图说内容为空]
         *
         * @param   {[type]}  range  [range description]
         *
         * @return  {[type]}         [return description]
         */
        function isEmptyImagenote(range) {
            return (
                range.collapsed &&
                range.startContainer == range.endContainer &&
                range.endOffset === range.startOffset &&
                range.endOffset === 0 &&
                $(range.startContainer).hasClass('imagenote')
            );
        }

        /**
         * [isOutLinkPic 是否为站外图片]
         *
         * @param   {[type]}  src      [src description]
         *
         * @return  {[type]}           [return description]
         */
        function isOutLinkPic(src) {
            return ueditorService.isOutLinkPic(src);
        }

        /**
         * [downloadPic 下载图片]
         *
         * @param   {[type]}  url        [url 图片地址]
         * @param   {[type]}  mediaType  [mediaType 渠道标识]
         *
         * @return  {[type]}             [return description]
         */
        function downloadPic(url, mediaType) {
            var defer = $q.defer();
            let downloadingPics = localStorageService.get('uedotor.downloadingpics');
            let downloadedPics = localStorageService.get('uedotor.downloadedPics');
            if (!downloadingPics) {
                downloadingPics = [];
            }
            if (!downloadedPics) {
                downloadedPics = {};
            }
            let urlMd5 = getUniqueId(url);
            if (downloadingPics[urlMd5]) {
                defer.resolve(downloadingPics[urlMd5]);
            }
            downloadingPics.push(url);
            localStorageService.set('uedotor.downloadingpics', downloadingPics);
            let params = {
                serviceid: 'mlf_metaviewdata',
                methodname: 'preDownload',
                MediaType: mediaType, // 当前渠道
                DownloadType: '1', // 资源类型， 1表示图片，2表示音频，3表示视频
                url: url,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(
                function (data) {
                    let downloadingPics = localStorageService.get('uedotor.downloadingpics');
                    angular.forEach(downloadingPics, function (item, index) {
                        if (item === data.ORIGINURL) {
                            downloadingPics.splice(index, 1);
                        }
                    });
                    localStorageService.set('uedotor.downloadingpics', downloadingPics);
                    if (data.ISSUCCESS === 'true') {
                        downloadedPics[urlMd5] = data.NEWURL;
                        localStorageService.set('uedotor.downloadedPics', downloadedPics);
                        defer.resolve(data.NEWURL);
                    } else {
                        defer.reject(data.MSG || '图片下载失败，请删除后手动上传');
                    }
                },
                function (data) {
                    let downloadingPics = localStorageService.get('uedotor.downloadingpics');
                    angular.forEach(downloadingPics, function (item, index) {
                        if (item === url) {
                            downloadingPics.splice(index, 1);
                        }
                    });
                    localStorageService.set('uedotor.downloadingpics', downloadingPics);
                    defer.reject(data.MSG || data.message || '图片下载失败，请删除后手动上传');
                }
            );
            return defer.promise;
        }

        /**
         * [selectNode 选区选中某个节点]
         *
         * @param   {[type]}  range  [range description]
         * @param   {[type]}  node   [node description]
         *
         * @return  {[type]}         [return description]
         */
        function selectNode(range, node) {
            range.setStartAtFirst(node);
            range.setEndAtLast(node);
            range.select();
        }

        /**
         * [isPicDownloading 图片是否正在预下载]
         *
         * @param   {[type]}  imgUrl  [imgUrl description]
         *
         * @return  {[type]}          [return description]
         */
        function isPicDownloading(imgUrl) {
            let isDownloading = false;
            let downloadingPics = localStorageService.get('uedotor.downloadingpics');
            angular.forEach(downloadingPics, function (downloadingpic) {
                if (downloadingpic === imgUrl) {
                    isDownloading = true;
                }
            });
            return isDownloading;
        }

        /**
         * [replaceImages 下载并替换图片]
         *
         * @param   {[type]}  ue    [ue description]
         * @param   {[type]}  waitDownloadPics    [waitDownloadPics description]
         * @param   {[type]}  htmlContent         [htmlContent description]
         * @param   {[type]}  mediaType           [mediaType description]
         * @param   {[type]}  $failImages         [$failImages description]
         *
         * @return  {[type]}                      [return description]
         */
        function replaceImages(ue, waitDownloadPics, htmlContent, mediaType, $failImages) {
            let defer = $q.defer();
            let result = {
                html: '',
            };
            // 1. 统计重复图片
            let toBeDownloadImages = [];
            let toBeDownloadUrls = [];
            let repeatImages = [];
            let htmlContentCopy = '';
            waitDownloadPics.forEach((item) => {
                let url = item.originSrc;
                if (toBeDownloadUrls.length) {
                    if (toBeDownloadUrls.indexOf(url) > -1) {
                        repeatImages.push(item);
                    } else {
                        toBeDownloadImages.push(item);
                        toBeDownloadUrls.push(url);
                    }
                } else {
                    toBeDownloadImages.push(item);
                    toBeDownloadUrls.push(url);
                }
                htmlContentCopy = htmlContent.replace(url, './static/jz.gif');
            });
            ue.setContent(htmlContentCopy);
            var replaceCount = toBeDownloadImages.length;
            toBeDownloadImages.forEach((item) => {
                let url = item.originSrc;
                if (!isPicDownloading(url)) {
                    let repeatCount = 0;
                    let htmlContentTemp = htmlContent;
                    let temUrl = url.replace(/&/gi, '&amp;');
                    while (htmlContentTemp.indexOf(temUrl) > -1) {
                        htmlContentTemp = htmlContentTemp.replace(temUrl, 'TEMP_PICTURE_PLACED');
                    }
                    let tmpReg = /TEMP_PICTURE_PLACED/gi;
                    let matchers = htmlContentTemp.match(tmpReg);
                    if (matchers && matchers.length) {
                        repeatCount = matchers.length;
                    }
                    downloadPic(url, mediaType).then((newUrl) => {
                        replaceCount--;
                        htmlContent = htmlContent.replace(temUrl, newUrl);
                        if (repeatCount) {
                            for (let j = repeatCount; j > 0; j--) {
                                htmlContent = htmlContent.replace(temUrl, newUrl);
                            }
                        }
                        while (htmlContent.indexOf(temUrl) > -1) {
                            htmlContent = htmlContent.replace(temUrl, newUrl);
                        }
                        while (htmlContent.indexOf(url) > -1) {
                            htmlContent = htmlContent.replace(url, newUrl);
                        }
                        if (replaceCount === 0) {
                            result.html = htmlContent;
                            defer.resolve(result);
                        }
                    }, (msg) => {
                        replaceCount--;
                        let failImg = {
                            url: url,
                            msg: msg
                        };
                        $failImages.push(failImg);
                        htmlContent = htmlContent.replace(temUrl, './static/picture_default.jpg');
                        if (repeatCount) {
                            for (let j = repeatCount; j > 0; j--) {
                                htmlContent = htmlContent.replace(temUrl, './static/picture_default.jpg');
                            }
                        }
                        while (htmlContent.indexOf(temUrl) > -1) {
                            htmlContent = htmlContent.replace(temUrl, './static/picture_default.jpg');
                        }
                        while (htmlContent.indexOf(url) > -1) {
                            htmlContent = htmlContent.replace(url, './static/picture_default.jpg');
                        }
                        if (replaceCount === 0) {
                            result.html = htmlContent;
                            defer.resolve(result);
                        }
                    });
                }
            });
            return defer.promise;
        }

        /**
         * [getBackgroundImgSrc 获取背景图片url]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function getBackgroundImgSrc(item) {
            let regExpUrl = /(http:|https:)?(\/\/)?[a-z-A-z\d]*(\.)?[a-z-A-z\d]+(\.)?[a-zA-z\d]+(\.(?:[a-zA-z\d]+))+(\:(?:\d+))?(\/?|(\/.+)?)$/g; //  匹配url
            let url = item.match(regExpUrl);
            url[0] = url[0].replace(/&quot;/gi, '');
            url[0] = url[0].replace(/\'/, '');
            url[0] = url[0].replace(')', '');
            let imgSrc = url[0];
            return imgSrc;
        }

        /**
         * [isAlreadyDeal 图片是否已经处理过--添加图说、绑定图片区域]
         *
         * @param   {[type]}  $image  [$iamge description]
         * @param   {[type]}  domUtils [domUtils description]
         *
         * @return  {[type]}          [return description]
         */
        function isAlreadyDeal($image, domUtils) {
            if ($image.attr('type') !== 'app_image') {
                return false;
            }
            if (!$image.hasClass('app_image')) {
                return false;
            }
            let appImageWrap = domUtils.findParent($image[0], function (node) {
                return $(node).hasClass('app_image_wrap');
            });
            if (!appImageWrap) {
                return false;
            }
            let appImageContainer = domUtils.findParent(appImageWrap, function (node) {
                return $(node).hasClass('app_image_container');
            });
            if (!appImageContainer) {
                return false;
            }
            return true;
        }

        /**
         * [getImgNextNode 获得下一个非空节点]
         *
         * @param   {[type]}  node      [node description]
         * @param   {[type]}  domUtils  [domUtils description]
         *
         * @return  {[type]}            [return description]
         */
        function getNextNode(node, domUtils) {
            let nextNode = domUtils.getNextDomNode(node);
            if ($(nextNode).children().length === 1 && domUtils.isBr($(nextNode).children()[0])) {
                nextNode = getNextNode(nextNode, domUtils);
            }
            return nextNode;
        }

        /**
         * [setStyleForImageNote 为图说设置样式]
         *
         * @param   {[type]}  imagenote  [imagenote description]
         *
         * @return  {[type]}             [return description]
         */
        function setStyleForImageNote(imagenote) {
            $(imagenote).css({
                marginTop: 1,
                paddingTop: 1,
                fontSize: 14,
                height: 'auto',
                color: '#8a939e',
                paddingBottom: 6,
                textAlign: 'left',
                boxSizing: 'initial',
                lineHeight: '1.5em',
                minHeight: '1.5em',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: '微软雅黑, "Microsoft YaHei"',
            });
        }

        /**
         * [fixImagenotePaste 修复图说粘贴]
         *
         * @param   {[type]}  imagenote  [imagenote description]
         * @param   {[type]}  evt        [evt description]
         * @param   {[type]}  ue         [ue description]
         *
         * @return  {[type]}             [return description]
         */
        function fixImagenotePaste(imagenote, evt, ue) {
            var clipboardData = evt.clipboardData || window.clipboardData;
            // 粘贴内容
            var paste = '';
            // 剪切板对象可以获取
            if (!clipboardData) {return;}
            // 阻止冒泡和默认粘贴行为
            evt.preventDefault();
            evt.stopPropagation();
            // 获取粘贴数据
            paste = clipboardData.getData('text') || '';
            paste = paste
                .replace(/\u3000/g, '')
                .replace(/\u200b/g, '')
                .replace(/\u200c/g, '');

            ue.execCommand('inserthtml', paste);
            return;
        }

        /**
         * [getUrlParam 获取URL中的query参数]
         *
         * @param   {[type]}  url   [url description]
         * @param   {[type]}  name  [name description]
         *
         * @return  {[type]}        [return description]
         */
        function getUrlParam(url, name) {
            let query = url.split('?')[1];
            if (!query) {
                return null;
            }
            let queryObj = {};
            let querys = query.split('&');
            querys.forEach(function (item) {
                queryObj[item.split('=')[0]] = item.split('=')[1];
            });
            return queryObj[name] || null;
        }

        /**
         * [getExifRotateDataOfImg 获取图片EXIF旋转信息]
         *
         * @param   {[type]}  img  [img 图片DOM节点]
         *
         * @return  {[type]}       [return description]
         */
        function getExifRotateDataOfImg(img) {
            return new Promise((resolve, reject) => {
                EXIF.getData(img, function () {
                    const exifData = EXIF.pretty(this);
                    if (!exifData) {
                        resolve('');
                    }
                    const Orientation = EXIF.getTag(this, 'Orientation');
                    resolve(Orientation);
                });
            });
        }

        /**
         * [dealEXIFRotateImg 处理EXIF带旋转信息的图片]
         *
         * @param   {[type]}  $img       [$img description]
         * @param   {[type]}  rotateDeg  [rotateDeg description]
         *
         * @return  {[type]}             [return description]
         */
        function dealEXIFRotateImg($img, rotateDeg) {
            if ($img.attr('isrotate')) {
                return;
            }
            const ratio = $img.width() / $img.height();
            const oldWidth = $img.width();
            const newWidth = parseInt($img.width() * ratio);
            const leftMargin = parseInt((oldWidth - newWidth) / 2); // 图片等比例缩小，并且是居中，则要计算图片左边距
            $img.rotate(rotateDeg);
            $img.attr('isRotate', rotateDeg);
            $img.css('height', oldWidth);
            $img.css('width', newWidth);
            $img.parent().addClass('rotate_img_container');
            $img.parent().css('height', newWidth);
            $img.parent().css('overflow', 'hidden');
            const marginTop = oldWidth - leftMargin - newWidth;
            $img.css('marginTop', -marginTop);
        }

        /**
         * [fixRotatePTag 修复图片旋转后回车后的p标签样式]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fixRotatePTag(ue) {
            let $rotatePTags = $(ue.body).find('.rotate_img_container');
            $rotatePTags.each(function () {
                var $tag = $(this);
                if (!$tag.find('img').length) {
                    $tag.attr('style', '');
                    $tag.removeClass('rotate_img_container');
                }
            });
        }

        /**
         * [fixBackGroundImg 修复微信背景图片下载]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fixBackGroundImg(ue) {
            let htmlContent = angular.copy($(ue.body).html());
            let regExp = /(background|background\-image)\s*\:\s*url\s*\(\s*(('|"|&quot;)?)\s*(\.\/|\/\/|http\:\/\/|https\:\/\/)([^\s]+)\2\s*\)/g; //  匹配正文中的background
            let backgroundGather = htmlContent.match(regExp);
            if (!backgroundGather) {
                return;
            }
            let failBackImg = backgroundGather.filter((item) => item.indexOf('./static/picture_default.jpg') > -1);
            if (!failBackImg.length) {
                return;
            } else {
                failBackImg.forEach(function (item, index) {
                    htmlContent = htmlContent.replace(backgroundGather[index], 'background-image:url()');
                });
                ue.setContent(htmlContent);
            }
        }

        /**
         * [getMediaType 获取渠道ID]
         *
         * @param   {[type]}  media  [media description]
         *
         * @return  {[type]}         [return description]
         */
        function getMediaType(media) {
            return {
                'weixin': '4',
                'app': '1',
                'iwo': '-1',
                'website': '2',
                'newspaper': '3',
                'weibo': '5',
                'broadcast': '16',
                'tv': '15',
                'scapp': '1',
                'trill': '17',
                'baijiahao': '18',
                'qiehao': '19',
                'toutiaohao': '20',
            }[media] || '1';
        }

        /**
         * [fixImgInPragraph 修复图片插入到段落文字中间后后面的文字没有标签包裹的问题]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fixImgInPragraph(ue) {
            let $body = $(ue.body);
            let $imageContainers = $body.find('.app_image_container');
            $imageContainers.each(function () {
                let $imageContainer = $(this);
                let targetNode = $imageContainer.parent()[0];
                if (targetNode.nextSibling && targetNode.nextSibling.nodeType === 3) {
                    $(targetNode.nextSibling).wrap('<p></p>');
                }
            });
            let $imgs = $body.find('img');
            $imgs.each(function () {
                let $imageContainer = $(this);
                let targetNode = $imageContainer.parent()[0];
                if (targetNode.nextSibling && targetNode.nextSibling.nodeType === 3) {
                    $(targetNode.nextSibling).wrap('<p></p>');
                }
            });
        }

        /**
         * [fixNoWidthImg 去除最大宽度为0的图片]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function fixNoWidthImg(ue) {
            let $body = $(ue.body);
            let $imgs = $body.find('img');
            $imgs.each(function () {
                let $img = $(this);
                if ($img.css('max-width') === '0px') {
                    $img.remove();
                }
            });
        }

        /**
         * [getUniqueId 获取唯一ID]
         *
         * @param   {[type]}  str  [str description]
         *
         * @return  {[type]}       [return description]
         */
        function getUniqueId(str) {
            return md5.createHash(str);
        }

        /**
         * [removeFailTips 移除失败图片提示]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function removeFailTips(ue) {
            let $tips = $(ue.body).find('.image_fail_tip');
            let $imgs = $(ue.body).find('img');
            if (!$tips.length) {
                if ($('.image-upload-error-info').length) {
                    $('.image-upload-error-info').remove();
                }
                return;
            }
            $('.image-upload-error-info').text('有' + $tips.length + '张图片预下载失败,  请删除图片后手动上传');
            $tips.each(function () {
                let $tip = $(this);
                let remove = true;
                let failId = $tip.attr('id');
                $imgs.each(function () {
                    let $img = $(this);
                    if ($img.attr('failid') === failId) {
                        remove = false;
                    }
                });
                if (remove) {
                    $tip.remove();
                    if ($('.image-upload-error-info').length) {
                        let failImageLength = $tips.length - 1;
                        $('.image-upload-error-info').text('有' + failImageLength + '张图片预下载失败,  请删除图片后手动上传');
                    }
                }
            });
        }


        /**
         * [removeFailImg 移除失败图片]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function removeFailImg(ue) {
            let $tips = $(ue.body).find('.image_fail_tip');
            let $imgs = $(ue.body).find('img');
            $imgs.each(function () {
                let $img = $(this);
                let remove = true;
                let failId = $img.attr('failid');
                if (!failId) {
                    remove = false;
                } else {
                    $tips.each(function () {
                        let $tip = $(this);
                        if ($tip.attr('id') === failId && $tip.find('img').length) {
                            remove = false;
                        }
                    });
                }
                if (remove) {
                    if ($img.parent()[0].TAGNAME === 'A') {
                        $img.parent().remove();
                    } else {
                        $img.remove();
                    }
                }
            });
        }

        /**
         * [isEditCenterImg 图片工具条对图片进行操作前判断是否为采编图片]
         *
         * @param   {[type]}  img  [img description]
         *
         * @return  {[type]}       [return description]
         */
        function isEditCenterImg(img) {
            const defer = $q.defer();
            const imgSrc = $(img).attr('src');
            const params = {
                methodname: 'validateTrsDownload',
                serviceid: 'mlf_metaviewdata',
                url: imgSrc,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (data.VALIDATETRSDOWNLOAD === 'true') {
                    defer.resolve(imgSrc);
                } else {
                    downloadPic(imgSrc).then(function (url) {
                        $(img).attr('src', url);
                        defer.resolve(url);
                    }, function (msg) {
                        modalDialog.alertType('图片下载失败!无法进行编辑', '', 'error', false);
                        defer.resolve(false);
                    });
                }
            }, function (data) {
                modalDialog.alertType('图片下载失败!无法进行编辑', '', 'error', false);
                defer.reject();
            });
            return defer.promise;
        }

        /**
         * [replaceWeixinVideoAndAudio 替换微信视频，非微信视频提示]
         *
         * @param   {[type]}  ue  [ue description]
         *
         * @return  {[type]}      [return description]
         */
        function replaceWeixinVideoAndAudio(ue) {
            let $imgs = $(ue.body).find('img');
            $imgs.each(function () {
                let $img = $(this);
                let $imgParent = $img.parent();
                if ($imgParent[0].tagName === 'A' && $imgParent.attr('href').indexOf('v.qq.com') !== -1) {
                    let iframeSrc = $imgParent.attr('href');
                    let iframeWidth = getUrlParam(iframeSrc, 'width') || 470;
                    let iframeHeight = getUrlParam(iframeSrc, 'height') || 480;
                    let iframe = `<p style="display:inline-block;width:100%;text-align:center;">
                    <iframe data-vidtype="1" width="${iframeWidth}" height="${iframeHeight}" src="${iframeSrc}" frameborder="0" align="center" allowfullscreen="1"></iframe></p>`;
                    $(iframe).insertAfter($imgParent);
                    $imgParent.remove();
                }
                if (isOuterVideoAndNotQQVideo($imgParent)) {
                    let failPictureUniqueId = getUniqueId($imgParent[0].href);
                    $img.attr('src', './images/video_default.png');
                    $img.attr('_src', './images/video_default.png');
                    $img.css('max-width', '470px');
                    $img.attr('failid', failPictureUniqueId);
                    let $note = $(
                        '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red; font-family:微软雅黑; font-size:10px;"><img width="20" height="20" style="display:inline-block;margin-right:5px;" src="./static/download_fail.png">非腾讯视频，可能无法播放或无法群发，请删除后手动添加腾讯视频链接</p>'
                    );
                    $note.insertAfter($imgParent);
                    $imgParent[0].href = '';
                }
            });
            let $audios = $(ue.body).find('audio');
            $audios.each(function () {
                let $audio = $(this);
                let img = document.createElement('img');
                let failPictureUniqueId = getUniqueId($audio.attr('src'));
                $(img).attr('src', './static/audio_default.jpg');
                $(img).attr('_src', './static/audio_default.jpg');
                $(img).css('max-width', '470px');
                $(img).attr('failid', failPictureUniqueId);
                $(img).insertAfter($audio);
                let $note = $(
                    '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red; font-family:微软雅黑; font-size:10px;"><img width="20" height="20" style="display:inline-block;margin-right:5px;" src="./static/download_fail.png">由于微信官方限制，暂时无法发布音频，建议删除</p>'
                );
                $note.insertAfter($(img));
                $audio.remove();
            });
            let $iframes = $(ue.body).find('iframe');
            $iframes.each(function () {
                let $iframe = $(this);
                let iframSrc = $iframe.attr('src');
                if (iframSrc.indexOf('v.qq.com') === -1) {
                    let img = document.createElement('img');
                    let failPictureUniqueId = getUniqueId(iframSrc);
                    $(img).attr('src', './images/video_default.png');
                    $(img).attr('_src', './images/video_default.png');
                    $(img).css('max-width', '470px');
                    $(img).attr('failid', failPictureUniqueId);
                    $(img).insertAfter($iframe);
                    let $note = $(
                        '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red; font-family:微软雅黑; font-size:10px;"><img width="20" height="20" style="display:inline-block;margin-right:5px;" src="./static/download_fail.png">非腾讯视频，可能无法播放或无法群发，请删除后手动添加腾讯视频链接</p>'
                    );
                    $note.insertAfter($(img));
                    $iframe.remove();
                }
            });
            let $videos = $(ue.body).find('video');
            $videos.each(function () {
                let $video = $(this);
                if ($video.attr('src') && $video.attr('src').indexOf('v.qq.com') === -1) {
                    let img = document.createElement('img');
                    let failPictureUniqueId = getUniqueId($video.attr('src'));
                    $(img).attr('src', './images/video_default.png');
                    $(img).attr('_src', './images/video_default.png');
                    $(img).css('max-width', '470px');
                    $(img).attr('failid', failPictureUniqueId);
                    $(img).insertAfter($video);
                    let $note = $(
                        '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red; font-family:微软雅黑; font-size:10px;"><img width="20" height="20" style="display:inline-block;margin-right:5px;" src="./static/download_fail.png">非腾讯视频，可能无法播放或无法群发，请删除后手动添加腾讯视频链接</p>'
                    );
                    $note.insertAfter($(img));
                    $video.remove();
                }
            });
        }

        /**
         * [isOuterVideoAndNotQQVideo 判断是否是外链视频并且不是腾讯视频]
         *
         * @param   {[type]}  $imgParent  [$imgParent description]
         *
         * @return  {[type]}              [return description]
         */
        function isOuterVideoAndNotQQVideo($imgParent) {
            return $imgParent[0].tagName === 'A' &&
                $imgParent.attr('href').indexOf('video') !== -1 &&
                $imgParent.attr('href').indexOf('v.qq.com') === -1 &&
                !$imgParent.parent().next().hasClass('image_fail_tip');
        }

        /**
         * [isImgFromWordPaste 判断图片是否为本地word图片引导上传的图片]
         *
         * @param   {[type]}  $img  [$img description]
         *
         * @return  {[type]}        [return description]
         */
        function isImgFromWordPaste($img) {
            return $img.attr('word_img') && $img.attr('src').indexOf('spacer.gif') > -1 && $img.css('background').indexOf('localimage.png') > -1;
        }

        /**
         * [localImgFailTip 本地图片无法上传时的提示（主要是从word粘贴图文过来）]
         *
         * @param   {[type]}  $img  [$img description]
         *
         * @return  {[type]}        [return description]
         */
        function localImgFailTip($img, index) {
            let failPictureUniqueId = getUniqueId($img.attr('src') + index);
            $img.attr('src', './static/picture_default.jpg');
            $img.attr('_src', './static/picture_default.jpg');
            $img.removeAttr('word_img');
            $img.css('background', '');
            $img.attr('failid', failPictureUniqueId);
            $img.attr('wordimgid', index);
            let $note = $(
                '<p class="image_fail_tip" id="' + failPictureUniqueId + '" style="color:red; font-family:微软雅黑; font-size:10px;"><img width="20" height="20" style="display:inline-block;margin-right:5px;" src="./static/download_fail.png" wordimgid="0">无法粘贴word图文中的图片，请手动上传</p>'
            );
            $note.insertAfter($img);
        }
    },
]);
